<template>
  <div>
    <v-toolbar style="background-color: white !important;">
      <v-btn icon @click="toPage('/account/')">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-avatar size="40px" class="user-photo" v-if="infofriend.type === 'user'">
        <img v-if="infofriend.data_room[0].profilepicture" :src="infofriend.data_room[0].profilepicture" class="alligator-turtle">
        <img v-else-if="infofriend.data_room[0].profilepicture === '' && infofriend.data_room[0].type === 'user'" :src="require('../assets/robot1.png')" class="alligator-turtle">
        <!-- <img v-else-if="infofriend.data_room[0].profilepicture === '' && infofriend.data_room[0].type === 'business'" src="/static/img/default_profile/business-white.png" class="alligator-turtle">
        <img v-else-if="infofriend.data_room[0].profilepicture === '' && infofriend.data_room[0].type === 'bot'" src="/static/img/default_profile/bot-white.png" class="alligator-turtle"> -->
        <img v-else :src="require('../assets/robot1.png')" class="alligator-turtle">
      </v-avatar>
      <v-avatar size="40px" class="user-photo" v-else-if="infofriend.type === 'group'">
        <img v-if="infofriend.picture" :src="infofriend.picture" class="alligator-turtle">
        <img v-else :src="require('../assets/group.png')" class="alligator-turtle">
      </v-avatar>
      <v-toolbar-title v-if="infofriend.type ==='user'">{{infofriend.data_room[0].name}}</v-toolbar-title>
      <v-toolbar-title v-else>{{infofriend.group_name}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- set webhook -->
      <v-layout class="ml-5 mr-3" justify-end align-center row wrap v-if="statemember === 'active'">
        <!-- <v-btn v-if="state_webhook" icon @click="unblock_webhook()">
          <v-icon>fas fa-comment-slash</v-icon>
        </v-btn>
        <v-btn v-else icon @click="block_webhook()">
          <v-icon>fas fa-comment</v-icon>
        </v-btn> -->
        <!-- <img style="cursor: pointer;" v-if="state_webhook" icon @click="unblock_webhook()" :src="require('@/assets/bot-slash.png')" width="24px">
        <img style="cursor: pointer;" v-else @click="block_webhook()" :src="require('@/assets/bot.png')" width="24px"> -->
        <img v-if="state_webhook" icon :src="require('@/assets/bot-slash.png')" width="24px">
        <img v-else :src="require('@/assets/bot.png')" width="24px">
      </v-layout>
      <v-layout class="ml-5 mr-3" row wrap justify-end align-center v-else>
        <!-- <v-btn v-if="state_webhook" icon disabled>
          <v-icon>fas fa-comment-slash</v-icon>
        </v-btn>
        <v-btn v-else icon disabled>
          <v-icon>fas fa-comment</v-icon>
        </v-btn> -->
        <img v-if="state_webhook" icon :src="require('@/assets/bot-slash.png')" width="24px">
        <img v-else :src="require('@/assets/bot.png')" width="24px">
      </v-layout>
      <!-- <v-flex xs3 sm3 md3 class="d-flex align-center"> -->
        <v-select
          class="selecStatus"
          :items="status_admin_list"
          v-model="status_admin"
          dense
          solo
          item-text="text"
          item-value="value"
          label="สถานะการตอบของแอดมิน"
          hide-details
          return-object
          :disabled="statemember !== 'active'"
          @input="setStateWithStatus()"
        >
          <template v-slot:item="{ item }">
            <v-flex xs2 sm2 md2>
              <v-icon :color="item.color">mdi-checkbox-blank-circle</v-icon>
            </v-flex>
            <v-flex class="ml-3">
              {{ item.text }}
            </v-flex>
          </template>
          <template v-slot:selection="{ item }">
            <v-icon :color="item.color" class="hidden-md-and-up">mdi-checkbox-blank-circle</v-icon>
            <span class="hidden-md-and-down">{{ item.text }}</span>
          </template>

        </v-select>
      <!-- </v-flex> -->
      <v-btn icon @click="toPageinfo()">
        <v-icon>more_vert</v-icon>
      </v-btn>
    </v-toolbar>
    <v-layout row wrap class="centerbox">
      <div class="chatbox" id="drop" v-on:drop="drop" v-on:dragover="allowDrop">
        <vue-context ref="menu" style="z-index: 1500;">
          <li v-for="(list, index) in ListMenuRightClick" :key="index">
              <a @click="SelectMenuRightClick(list.methods)">{{list.message}}</a>
          </li>
        </vue-context>
      <!-- modal pdf -->
      <div id="myModalFile" class="modalc">
        <div id="headcaption">
          <v-container class="hidden-sm-and-down">
            <v-layout row wrap>
              <v-flex xs1 style="text-align: right; padding-right: 2vw;">
                <v-avatar class="user-photo">
                  <img v-if="picSend" :src="picSend" class="alligator-turtle">
                  <img v-else-if="typeuser === 'business'" :src="require('../assets/robot1.png')" class="alligator-turtle">
                  <img v-else-if="typeuser === 'bot'" :src="require('../assets/robot1.png')" class="alligator-turtle">
                  <img v-else :src="require('../assets/robot1.png')" class="alligator-turtle">
                </v-avatar>
              </v-flex>
              <v-flex xs7>
                <b style="font-size: 14px;"> {{filenameSend}} </b>
                <p style="font-size: 12px;"> ส่งโดย {{nicknameSend}} &nbsp;&nbsp;| &nbsp;{{dateSend}} <v-icon style="font-size:7px !important; color: white !important;">schedule</v-icon>{{timeSend}}
               </p>
              </v-flex>
              <v-flex xs4>
                <v-btn depressed small  class="btnallow CSChatThai" id="btn-download" @click="loadfile(filenameSend)" :loading="loading" :disabled="loading">
                  <v-icon>file_download</v-icon>&nbsp; บันทึก
                </v-btn>
                <!-- <v-btn depressed small class="btncancel" @click="sendimgonebox(tokenmsgSend)">
                  <v-icon>cloud_upload</v-icon> &nbsp;
                    ส่งไป onebox
                </v-btn> -->
              </v-flex>
                <span class="closeR" @click="closemodal()">&times;</span>
            </v-layout>
          </v-container>
          <v-container class="hidden-md-and-up">
            <v-layout row wrap>
              <v-flex xs2 md2 sm2 style="text-align: right; padding-right: 2vw;">
                <v-avatar class="user-photo">
                  <img v-if="picSend" :src="picSend" class="alligator-turtle">
                  <img v-else-if="typeuser === 'business'" :src="require('../assets/robot1.png')" class="alligator-turtle">
                  <img v-else-if="typeuser === 'bot'" :src="require('../assets/robot1.png')" class="alligator-turtle">
                  <img v-else :src="require('../assets/robot1.png')" class="alligator-turtle">
                </v-avatar>
              </v-flex>
              <v-flex xs9 md9 sm9>
                <p style="font-size: 14px; white-space: nowrap; width: 16em; overflow: hidden; text-overflow: ellipsis;font-weight: bold;"> {{filenameSend}} </p>
                <p style="font-size: 12px; white-space: nowrap; width: 20em; overflow: hidden; text-overflow: ellipsis;"> ส่งโดย {{nicknameSend}}
                </p>
                <p style="font-size: 12px;">วันที่ &nbsp;{{dateSend}} <v-icon style="font-size:7px !important; color: white !important;">schedule</v-icon>{{timeSend}}
                </p>
              </v-flex>
              <v-flex xs1 md1 sm1>
                <span class="closeR" @click="closemodal()">&times;</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md12 sm12 style="margin-left: 15vw;">
                <v-btn depressed small  class="btnallow" @click="loadfile(filenameSend)" :loading="loading" :disabled="loading">
                  <v-icon>file_download</v-icon>&nbsp;
                    บันทึก
                </v-btn>
                <!-- <v-btn depressed small class="btncancel" @click="sendimgonebox(tokenmsgSend)">
                  <v-icon>cloud_upload</v-icon> &nbsp;
                    ส่งไป onebox
                </v-btn> -->
              </v-flex>
            </v-layout>
          </v-container>
        </div>
          <iframe :src="filepdf" style="width:100%; height:100%;justify-content: center;" frameborder="0"></iframe>
          <!-- <div style="overflow-y: scroll; height: 90%;">
              <pdf
                v-for="i in numPages"
                :key="i"
                :page="i"
                :src="filepdf"
                ref="myPdfComponent">
              </pdf>
            </div> -->
      </div>
      <!-- modal pic -->
      <div id="myModalImage" class="modalc">
        <div id="headcaption">
          <v-container class="hidden-sm-and-down">
            <v-layout row wrap>
              <v-flex xs1 style="text-align: right; padding-right: 2vw;">
                <v-avatar class="user-photo">
                  <img v-if="picSend" :src="picSend" class="alligator-turtle">
                  <img v-else-if="typeuser === 'business'" :src="require('../assets/robot1.png')" class="alligator-turtle">
                  <img v-else-if="typeuser === 'bot'" :src="require('../assets/robot1.png')" class="alligator-turtle">
                  <img v-else :src="require('../assets/robot1.png')" class="alligator-turtle">
                </v-avatar>
              </v-flex>
              <v-flex xs7>
                <b style="font-size: 14px;"> {{filenameSend}} </b>
                <p style="font-size: 12px;"> ส่งโดย {{nicknameSend}} &nbsp;&nbsp;| &nbsp;{{dateSend}} <v-icon style="font-size:7px !important; color: white !important;">schedule</v-icon>{{timeSend}}
               </p>
              </v-flex>
              <v-flex xs4>
                <v-btn depressed small  class="btnallow CSChatThai" id="btn-download" @click="loadfile(filenameSend)" :loading="loading" :disabled="loading">
                  <v-icon>file_download</v-icon>&nbsp; บันทึก
                </v-btn>
                <!-- <v-btn depressed small class="btncancel" @click="sendimgonebox(tokenmsgSend)">
                  <v-icon>cloud_upload</v-icon> &nbsp;
                    ส่งไป onebox
                </v-btn> -->
              </v-flex>
                <span class="closeR" @click="closemodal()">&times;</span>
            </v-layout>
          </v-container>
          <v-container class="hidden-md-and-up">
            <v-layout row wrap>
              <v-flex xs2 md2 sm2 style="text-align: right; padding-right: 2vw;">
                <v-avatar class="user-photo">
                  <img v-if="picSend" :src="picSend" class="alligator-turtle">
                  <img v-else-if="typeuser === 'business'" :src="require('../assets/robot1.png')" class="alligator-turtle">
                  <img v-else-if="typeuser === 'bot'" :src="require('../assets/robot1.png')" class="alligator-turtle">
                  <img v-else :src="require('../assets/robot1.png')" class="alligator-turtle">
                </v-avatar>
              </v-flex>
              <v-flex xs9 md9 sm9>
                <p style="font-size: 14px; white-space: nowrap; width: 16em; overflow: hidden; text-overflow: ellipsis;font-weight: bold;"> {{filenameSend}} </p>
                <p style="font-size: 12px; white-space: nowrap; width: 20em; overflow: hidden; text-overflow: ellipsis;"> ส่งโดย {{nicknameSend}}
                </p>
                <p style="font-size: 12px;">วันที่ &nbsp;{{dateSend}} <v-icon style="font-size:7px !important; color: white !important;">schedule</v-icon>{{timeSend}}
                </p>
              </v-flex>
              <v-flex xs1 md1 sm1>
                <span class="closeR" @click="closemodal()">&times;</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md12 sm12 style="margin-left: 15vw;">
                <v-btn depressed small  class="btnallow" @click="loadfile(filenameSend)" :loading="loading" :disabled="loading">
                  <v-icon>file_download</v-icon>&nbsp;
                    บันทึก
                </v-btn>
                <!-- <v-btn depressed small class="btncancel" @click="sendimgonebox(tokenmsgSend)">
                  <v-icon>cloud_upload</v-icon> &nbsp;
                    ส่งไป onebox
                </v-btn> -->
              </v-flex>
            </v-layout>
          </v-container>
        </div>
          <img class="modal-contentc" id="img01">
      </div>
        <v-flex xs12 sm12 md12 xl12 lg12 class="chatlogs" id="myscroll" :style="chatlogsFlex"  v-on:scroll="get_scroll">
          <div v-if="progressLoadChat">
            <v-progress-linear :indeterminate="progressLoadChat"></v-progress-linear>
          </div>
          <v-layout row wrap  v-for="(item,index) in listmessage" :key="index">
            <!-- read -->
            <!-- <v-layout row wrap justify-center style="margin-bottom: 15px;">
              <v-icon>fas fa-check-circle</v-icon>
            </v-layout> -->
            <!-- date -->
            <v-layout row wrap justify-center style="margin-bottom: 15px;">
              <div v-if="index == 0">
                <!-- <div class="text-xs-center" @click="loadchathistory" v-if="statusload">
                  <v-btn round outline color="primary" style="background: #ff000000 !important;text-transform: none;" disabled><v-icon left style="font-size: 25px !important;" @click="loadchathistory">refresh</v-icon>โหลดข้อความก่อนหน้า</v-btn>
                </div> -->
                <div class="conversation-start" style="text-align:center;" v-if="tokenrooomSelect === item.tokenroom">
                    <span>{{dateMoment(item.timestamp)}} </span>
                </div>
              </div>
              <div v-else-if="dateMoment(item.timestamp) !== dateMoment(listmessage[index-1].timestamp)">
                <br>
                <v-flex xl12 md12 sm12 lg12>
                <div class="conversation-start" style="text-align:center;" v-if="tokenrooomSelect === item.tokenroom">
                    <span>{{dateMoment(item.timestamp)}}</span>
                 </div>
               </v-flex>
              </div>
            </v-layout>
            <!--============ TYPE USER =============-->
            <v-flex xs12 ml-3 mb-2 v-if="item.tokenuser !== tokenuser" >
              <v-avatar @click="detailFriendDialog(item)" class="f-l mr-2" style="float: left; height: 40px; width: 40px; cursor: pointer;" v-if="item.typeofmessage !== 'unsend_message' && item.typeofmessage !== 'system_action_albums' && item.typeofmessage !== 'system_action_task' && item.typeofmessage !== 'system_action'">
                <img :src="item.path_pic" v-if="item.path_pic" class="alligator-turtle">
                <img :src="require('../assets/robot1.png')" alt="John" v-else class="alligator-turtle">
              </v-avatar>
              <!-- message -->
              <div class="f-r chat_other"  v-if="item.typeofmessage === 'message'" @click="handleClickTest" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')" style="cursor: pointer;">
              </div>
              <!-- unsend_message -->
              <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 1vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'unsend_message'">
                <p class="boxother_unsend">
                  {{item.nickname}} ยกเลิกข้อความ
                </p>
              </v-flex>
              <!-- system_action_albums -->
              <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 1vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action_albums'">
                <p class="boxother_unsend" v-if="item.message == 'edit_name_albums'">
                  <span style="font-size: 13px;">
                  {{timeMoment(item.timestamp)}} น. <br />
                  {{item.nickname}} แก้ไขอัลบั้ม
                  </span>
                </p>
                <p class="boxother_unsend" v-else-if="item.message == 'create_albums'">
                  <span style="font-size: 13px;">
                  {{timeMoment(item.timestamp)}} น. <br />
                  {{item.nickname}} สร้างอัลบั้ม
                  </span>
                </p>
                <p class="boxother_unsend" v-else-if="item.message == 'delete_albums'">
                  <span style="font-size: 13px;">
                  {{timeMoment(item.timestamp)}} น. <br />
                  {{item.nickname}} ลบอัลบั้ม
                  </span>
                </p>
                <p class="boxother_unsend" v-else-if="item.message == 'delete_images_albums'">
                  <span style="font-size: 13px;">
                  {{timeMoment(item.timestamp)}} น. <br />
                  {{item.nickname}} ลบรูปภาพในอัลบั้ม
                  </span>
                </p>
              </v-flex>
              <!-- system_action_task -->
              <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 1vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action_task'">
                <p class="boxother_unsend" v-if="item.message == 'edit_task'">
                  <span style="font-size: 13px;">
                  {{timeMoment(item.timestamp)}} น. <br />
                  {{item.nickname}} แก้ไขการ์ดงาน
                  </span>
                </p>
                <p class="boxother_unsend" v-else-if="item.message == 'create_project'">
                  <span style="font-size: 13px;">
                  {{timeMoment(item.timestamp)}} น. <br />
                  {{item.nickname}} สร้างโปรเจค
                  </span>
                </p>
              </v-flex>
              <!-- system_action -->
              <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 1vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action'">
                <p class="boxother_unsend" v-if="item.message == 'invite'">
                  <span style="font-size: 13px;">
                  {{timeMoment(item.timestamp)}} น. <br />
                  {{item.nickname}} เชิญ {{item.file_name}}
                  </span>
                </p>
                <p class="boxother_unsend" v-else-if="item.message == 'active'">
                  <span style="font-size: 13px;">
                  {{timeMoment(item.timestamp)}} น. <br />
                  {{item.nickname}} เข้าร่วมกลุ่ม
                  </span>
                </p>
                <p class="boxother_unsend" v-else-if="item.message == 'kick'">
                  <span style="font-size: 13px;">
                  {{timeMoment(item.timestamp)}} น. <br />
                  {{item.nickname}} ลบ {{item.file_name}} ออกจากกลุ่ม
                  </span>
                </p>
                <p class="boxother_unsend" v-else-if="item.message == 'leave'">
                  <span style="font-size: 13px;">
                  {{timeMoment(item.timestamp)}} น. <br />
                  {{item.nickname}} ออกจากกลุ่ม
                  </span>
                </p>
              </v-flex>
              <!-- get quickreply date -->
              <p v-else-if="item.typeofmessage === 'date'" class="f-r chat_other">
                <v-icon style="font-size: 18px; color:#4065b4;"> far fa-calendar-alt</v-icon> &nbsp; {{dateMoment(item.message)}}
              </p>
              <!-- get quickreply datetime-->
              <p v-else-if="item.typeofmessage === 'datetime'" class="f-r chat_other">
                <v-icon style="font-size: 18px; color:#4065b4;"> far fa-calendar-alt</v-icon> &nbsp; {{dateMoment(item.message)}}
                <br>
                <v-icon style="font-size: 16px;"> far fa-clock</v-icon> &nbsp; เวลา {{item.message.split('T')[1]}} น.
              </p>
              <!-- mention_message -->
              <div  v-else-if="item.typeofmessage === 'mention_message'" class="f-r chat_other">
                <v-layout row wrap style="padding-bottom: 10px;" v-if="item.source_message.typeofmessage !== 'unsend_message'">
                  <v-flex xs1>
                    <v-avatar>
                      <img :src="item.source_message.owner_source_message.path_pic" v-if="item.source_message.owner_source_message.path_pic" class="alligator-turtle" style="width: 40px; height: 40px;">
                      <img :src="require('../assets/robot1.png')" class="alligator-turtle" v-else style="width: 40px; height: 40px;">
                    </v-avatar>
                  </v-flex>
                  <v-flex xs11 style="padding-left: 40px;">
                    <v-layout column v-if="item.source_message.typeofmessage === 'message'">
                      <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                      <span>{{item.source_message.message}}</span>
                    </v-layout>
                    <v-layout row v-else-if="item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker'">
                      <v-flex xs8>
                        <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                        <br>
                        <span v-if="item.source_message.typeofmessage === 'image'">รูปภาพ</span>
                        <span v-else>สติ๊กเกอร์</span>
                      </v-flex>
                      <v-flex xs4>
                        <img :src="item.source_message.message" style="width: 40px; height: 40px; border-radius: 10px; float: right;">
                      </v-flex>
                    </v-layout>
                    <v-layout row v-else-if="item.source_message.typeofmessage === 'file'">
                      <v-flex xs8>
                        <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                        <br>
                        <span>ไฟล์</span>
                      </v-flex>
                      <v-flex xs4>
                        <v-icon v-if="extension(item.source_message.message) === 'pdf'" style="color: black; width: 40px; height: 40px; float: right;">fas fa-file-pdf</v-icon>
                        <v-icon v-else style="color: black; width: 40px; height: 40px; float: right;">{{extension(item.source_message.message)}}</v-icon>
                      </v-flex>
                    </v-layout>
                    <v-layout column v-else-if="item.source_message.typeofmessage === 'video'">
                      <v-flex xs12>
                        <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                        <br>
                      </v-flex>
                      <v-flex xs12>
                        <!-- <video width="100" height="100" controls style="justify-content: center; align-items: center;">
                          <source :src="item.source_message.message" :type="'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]">
                        </video> -->
                        <video v-if="extension(item.source_message.message) === 'media'" width="100" height="100" controls style="justify-content: center; align-items: center;">
                          <source :src="item.source_message.message" :type="'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]">
                        </video>
                        <div v-else style="height: 100px; width: 100%; justify-content: center; align-items: center;">
                          <vplayer
                            style="height: 100px !important; width: 100px !important;"
                            :playerOptions="{
                              type: 'application/x-mpegURL',
                              src: item.source_message.message,
                              preload: true,
                              autoplay: false,
                              isLoop: false,
                              playsinline: false,
                              poster: '',
                              controls: 'progress,current,durration',
                              crossOrigin: false
                            }"
                            @onplay="play"
                          />
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row v-else-if="item.source_message.typeofmessage === 'location'">
                      <v-flex xs8>
                        <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                        <br>
                        <span v-if="item.source_message.address !== ''">{{item.source_message.address}}</span>
                        <span v-else>{{item.source_message.message}}</span>
                      </v-flex>
                      <v-flex xs4>
                        <v-icon style="color: black; width: 40px; height: 40px; float: right;">fas fa-map-marker-alt</v-icon>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row wrap style="padding-bottom: 10px;" v-else>
                  <span>ไม่สามารถแสดงข้อความนี้ได้</span>
                </v-layout>
                <v-divider></v-divider>
                <span style="font-weight: 500;" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')"></span>
              </div>
              <!-- albums_message -->
              <div slot="activator" v-else-if="item.typeofmessage === 'albums_message' && item.image_add.length !== 0" style="width: 240px;" class="chat_other">
                <h3 class="mb-1" v-if="item.message !== 'addimage_albums'" style="color:#3a506d !important;">สร้างอัลบั้ม</h3>
                <h3 class="mb-1" v-else style="color:#3a506d !important;">
                  เพิ่มรูปภาพใน {{item.albums_name}}
                </h3>
                <v-layout row wrap justify-center align-center>
                  <img :src="item.image_add[0].link" height="150px" width="130px" style="border-radius: 10px;" v-if="item.image_add.length!=0">
                </v-layout>
                <p class="mt-1 mb-0" style="color: #3a506d91 !important;">
                  รวม: {{item.image_add.length}} ภาพ
                </p>
                <v-divider style="border-color: #31394121 !important;"></v-divider>
                <v-layout row wrap justify-center align-center class="mt-2">
                  <h4 v-if="item.albums_name != ''" style="color:#4c6281 !important;">{{item.albums_name}}</h4>
                  <h4 v-else style="color:#4c6281 !important;">{{dateMoment(item.create_date)}}</h4>
                  <v-spacer></v-spacer>
                  <v-icon style="font-size: 16px;color:#4c6281 !important;">fas fa-chevron-right</v-icon>
                </v-layout>
              </div>
              <!-- task_message -->
              <div slot="activator" v-else-if="item.typeofmessage === 'task_message'" style="width: 240px; height: auto; background-color:#e0e0e0;" class="chat_other">
                <div class="mb-1" v-if="item.message === 'create_task'">
                  <v-layout row>
                    <v-flex xs2>
                      <v-card v-if="item.priority === '1'" dark tile flat color="#b3493d" style="border-radius: 7px; width: 15px; height: 50px;">
                      </v-card>
                      <v-card v-if="item.priority === '2'" dark tile flat color="#f4c067" style="border-radius: 7px; width: 15px; height: 50px;">
                      </v-card>
                      <v-card v-if="item.priority === '3'" dark tile flat color="#a0a1a3" style="border-radius: 7px; width: 15px; height: 50px;">
                      </v-card>
                    </v-flex>
                    <v-flex>
                      <p style="padding-top: 0.5px;">
                        <font style="font-size: 1.5em; font-weight: bold; color: #3f516c; ">{{ item.project_name }}</font><br />
                        <font style="font-size: 1.1em; font-weight: bold; color: #657996;">{{ item.title }}</font>
                      </p>
                    </v-flex>
                  </v-layout>
                  <v-divider style="border-color: #31394121 !important; padding-bottom: 1px;"></v-divider>
                  <v-flex>
                    <p style="padding-top: 4px;">
                      <font style="font-size: 1.1em; font-weight: bold;" v-if=" item.detail !== ''">{{ item.detail }}</font>
                      <font style="font-size: 1.1em; font-weight: bold;" v-if=" item.detail === ''">-</font>
                      <br /><font style="font-size: 1.1em; font-weight: normal; color: #8297b6;">ผู้รับผิดชอบ:</font><br />
                      <v-flex
                        style="margin-left: 5px;"
                        v-for="(message, i) in item.task_info.assign"
                        :key="i"
                      >
                        <v-chip size="34px" style="background-color:#b3afaf;">
                          <v-avatar>
                            <v-img :src="message.path_pic" v-if="message.path_pic" class="alligator-turtle"></v-img>
                          </v-avatar>
                          <font style="font-size: 1.1em; font-weight: normal; padding-left: 3px;" class="long_text">{{ message.nickname }}</font>
                        </v-chip>
                      </v-flex>
                      <v-flex style="padding-top: 8px; text-align: center; margin-left: 6px; margin-top:15px; border: 1px solid white; border-radius: 5px; width: 80px; height: 40px;">
                        <font style="font-size: 1.1em; font-weight: normal; color: #989797;">{{ item.task_info.state.name }}</font>
                      </v-flex>
                    </p>
                  </v-flex>
                </div>
                <div class="mb-1" v-else>
                  <v-layout row>
                    <v-flex xs2>
                      <v-card v-if="item.priority === '1'" dark tile flat color="#b3493d" style="border-radius: 7px; width: 15px; height: 50px;">
                      </v-card>
                      <v-card v-if="item.priority === '2'" dark tile flat color="#f4c067" style="border-radius: 7px; width: 15px; height: 50px;">
                      </v-card>
                      <v-card v-if="item.priority === '3'" dark tile flat color="#a0a1a3" style="border-radius: 7px; width: 15px; height: 50px;">
                      </v-card>
                    </v-flex>
                    <v-flex>
                      <p style="padding-top: 0.5px;">
                        <font style="font-size: 1.5em; font-weight: bold; color: #3f516c" class="long_text">{{ item.project_name }}</font><br />
                        <font style="font-size: 1.1em; font-weight: bold; color: #657996" class="long_text">{{ item.title }}</font>
                      </p>
                    </v-flex>
                  </v-layout>
                  <v-divider style="border-color: #31394121 !important; padding-bottom: 1px;"></v-divider>
                  <v-flex>
                    <p style="padding-top: 4px;">
                      <font style="font-size: 1.1em; font-weight: bold;" v-if=" item.detail !== ''">{{ item.detail }}</font>
                      <font style="font-size: 1.1em; font-weight: bold;" v-if=" item.detail === ''">-</font>
                      <br /><font style="font-size: 1.1em; font-weight: normal; color: #8297b6;">ผู้รับผิดชอบ:</font><br />
                      <v-flex
                        style="margin-left: 5px;"
                        v-for="(message, i) in item.task_info.assign"
                        :key="i"
                      >
                        <v-chip size="34px" style="background-color:#b3afaf;">
                          <v-avatar>
                            <v-img :src="message.path_pic" v-if="message.path_pic" class="alligator-turtle"></v-img>
                          </v-avatar>
                          <font style="font-size: 1.1em; font-weight: normal; padding-left: 3px;" class="long_text">{{ message.nickname }}</font>
                        </v-chip>
                      </v-flex>
                    </p>
                  </v-flex>
                </div>
              </div>
              <!-- image -->
              <div class="f-r"  v-else-if="item.typeofmessage === 'image'">
                <!-- <img :src="item.message" height="200px" class="chat_otherimage" @click="zoom(item)"> -->
                <img :src="item.message" height="200px" class="chat_otherimage" @click="zoom(item)">
              </div>
              <!-- file -->
              <div  v-else-if="item.typeofmessage === 'file' && (extension(item.file_name) === 'pdf' || extension(item.file_name) === 'media' || extension(item.file_name) === 'audio')">
                <v-flex xs12 v-if="extension(item.file_name) === 'pdf'" class="f-r chat_otherfile">
                  <v-layout row wrap>
                    <v-flex xs12 md12 sm12 lg12 xl12>
                      <v-card-media style="height: 95px; border-radius: 10px; cursor: pointer;" @click="zoomfile(item, false)">
                        <pdf
                        :src="item.message"
                        :page="1"
                        ref="myPdfComponent">
                        </pdf>
                      </v-card-media>
                    </v-flex>
                    <v-flex xs12 md12 sm12 lg12 xl12>
                      <div class="text2">{{item.file_name}}</div>
                    </v-flex>
                  </v-layout>
                  <v-divider style="margin-top: 10px;"></v-divider>
                  <v-layout row wrap align-center justify-end>
                    <v-btn flat icon color="blue" @click="loadfilepdf(item)" :loading="loadingpdf" :disabled="loadingpdf">
                      <v-icon style="color: black; font-size: 25px !important;">file_download</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-else-if="extension(item.file_name) === 'audio'" class="f-r chat_otherfile">
                  <audio controls style="width: 175px !important;">
                    <source :src="item.message" :type="'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                  </audio>
                  <v-flex xs12>
                    <div class="text2">{{item.file_name}}</div>
                  </v-flex>
                  <v-divider style="margin-top: 10px;"></v-divider>
                  <v-layout row wrap align-center justify-end>
                    <v-btn flat icon color="blue" @click="downloadURI(item)">
                      <v-icon style="color: black; font-size: 25px !important;">file_download</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-else-if="extension(item.file_name) === 'media'" class="chat_othervideo">
                  <video style="width: 177px !important; height: 130px !important;" controls disablePictureInPicture controlsList="nodownload noFullscreen">
                    <source :src="item.message" :type="'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                  </video>
                  <v-flex xs12>
                    <div class="text2">{{item.file_name}}</div>
                  </v-flex>
                  <v-divider style="margin-top: 5px;"></v-divider>
                  <v-layout row align-center justify-end>
                    <v-flex xs2>
                      <v-btn flat icon color="blue" @click="previewvideo(item)">
                        <v-icon style="color: black; font-size: 20px !important;">fas fa-expand</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs3>
                      <v-btn flat icon color="blue" @click="downloadURI(item)">
                        <v-icon style="color: black; font-size: 25px !important;">file_download</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-else class="f-r chat_otherfile">
                  <v-layout row wrap>
                    <v-flex xs6 md6 sm6 lg6 xl6>
                      <v-icon style="color: black; font-size: 60px !important; margin-top: 1vh; justify-content: center; display: flex;">{{extension(item.file_name)}}</v-icon>
                    </v-flex>
                    <v-flex xs6 md6 sm6 lg6 xl6>
                      <div class="textfile">{{item.file_name}}</div>
                    </v-flex>
                  </v-layout>
                  <v-divider style="margin-top: 10px;"></v-divider>
                  <v-layout row wrap align-center justify-end>
                    <v-btn flat icon color="blue" @click="loadfilepdf(item)">
                      <v-icon style="color: black; font-size: 25px !important;">file_download</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
              </div>
              <div class="f-r chat_otherfile" v-else-if="item.typeofmessage === 'file'">
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs6 md6 sm6 lg6 xl6>
                      <v-icon style="color: black; font-size: 60px !important; margin-top: 1vh; justify-content: center; display: flex;">{{extension(item.file_name)}}</v-icon>
                    </v-flex>
                    <v-flex xs6 md6 sm6 lg6 xl6>
                      <div class="textfile">{{item.file_name}}</div>
                    </v-flex>
                  </v-layout>
                  <v-divider style="margin-top: 10px;"></v-divider>
                  <v-layout row wrap align-center justify-end>
                    <v-btn flat icon color="blue" @click="loadfilepdf(item)">
                      <v-icon style="color: black; font-size: 25px !important;">file_download</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
              </div>
              <!-- video -->
              <div  v-else-if="item.typeofmessage === 'video' && (extension(item.file_name) === 'media' || extension(item.file_name) === 'audio')" class="f-r chat_othervideo">
                <v-flex xs12 v-if="extension(item.file_name) === 'audio'">
                  <audio controls style="width: 175px !important;">
                    <source :src="item.message" :type="'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                  </audio>
                  <v-flex xs12>
                    <div class="text2">{{item.file_name}}</div>
                  </v-flex>
                  <v-divider style="margin-top: 10px;"></v-divider>
                  <v-layout row wrap align-center justify-end>
                    <v-btn flat icon color="blue" @click="downloadURI(item)">
                      <v-icon style="color: black; font-size: 25px !important;">file_download</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-else-if="extension(item.message) === 'media'">
                  <video style="width: 177px !important; height: 130px !important;" controls disablePictureInPicture controlsList="nodownload noFullscreen">
                    <source :src="item.message" :type="'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                  </video>
                  <v-flex xs12>
                    <div class="text2">{{item.file_name}}</div>
                  </v-flex>
                  <v-divider style="margin-top: 5px;"></v-divider>
                  <v-layout row wrap align-center justify-end>
                    <v-flex xs2>
                      <v-btn flat icon color="blue" @click="previewvideo(item)">
                        <v-icon style="color: black; font-size: 20px !important;">fas fa-expand</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs3>
                      <v-btn flat icon color="blue" @click="downloadURI(item)">
                        <v-icon style="color: black; font-size: 25px !important;">file_download</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-else>
                  <vplayer
                  :playerOptions="{
                    type: 'application/x-mpegURL',
                    src: item.message,
                    preload: true,
                    autoplay: false,
                    isLoop: false,
                    playsinline: false,
                    poster: item.thumbnail,
                    controls: 'progress,current,durration,volume',
                    crossOrigin: false
                  }"
                    @onplay="play"
                  />
                  <v-flex xs12>
                    <div class="text2">{{item.file_name}}</div>
                  </v-flex>
                  <v-divider style="margin-top: 5px;"></v-divider>
                  <v-layout row wrap align-center justify-end>
                    <v-flex xs2>
                      <v-btn flat icon color="blue" @click="previewvideo(item)">
                        <v-icon style="color: black; font-size: 20px !important;">fas fa-expand</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs3>
                      <v-btn flat icon color="blue" @click="downloadURI(item)">
                        <v-icon style="color: black; font-size: 25px !important;">file_download</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </div>
              <!-- sticker -->
              <div class="f-r"  v-else-if="item.typeofmessage === 'sticker'">
                <img :src="item.file_name" class="chat_othersticker">
              </div>
              <!-- contact -->
              <div class="f-r chat_othercontact"  v-else-if="item.typeofmessage === 'contact'">
                <v-layout align-center justify-center row wrap>
                  <v-flex xs5 md5 sm5>
                    <v-layout align-center justify-center row wrap>
                      <v-avatar class="user-photo" >
                        <img v-if="item.pic_contact" :src="item.pic_contact" class="alligator-turtle">
                        <img v-else :src="require('../assets/robot1.png')" class="alligator-turtle">
                      </v-avatar>
                    </v-layout>
                  </v-flex>
                  <v-flex xs5 md5 sm5>
                    <v-layout align-center justify-center row wrap style="margin-top: 12px;">
                      <p class="text2">{{item.nickname_contact}}</p>
                    </v-layout>
                  </v-flex>
                  <v-flex xs2 md2 sm2>
                    <v-layout align-center justify-end row wrap>
                      <v-icon>navigate_next </v-icon>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </div>
              <!-- location -->
              <div class="chat_othernote f-r" v-else-if="item.typeofmessage === 'location'">
                <v-layout align-center justify-center row wrap>
                  <v-flex xs2 md2 sm2>
                    <img :src="require('../assets/location.png')" style="height: 40px; width: 40px;">
                  </v-flex>
                  <v-flex xs10 md10 sm10 v-if="item.file_name !== ''">
                    <span>{{ item.file_name }}</span>
                  </v-flex>
                  <v-flex xs10 md10 sm10 v-else>
                    <span>{{ item.message }}</span>
                  </v-flex>
                </v-layout>
              </div>
              <!-- note -->
              <div class="f-r chat_othernote" v-else-if="item.typeofmessage === 'note'">
                <v-flex xs12>
                  <v-layout row wrap align-start justify-start>
                    <v-flex xs6>
                      <span>{{item.message}}</span>
                    </v-flex>
                  </v-layout>
                  <v-divider style="margin-top: 10px;"></v-divider>
                  <v-layout row wrap align-center>
                    <span>โน๊ต</span>
                    <v-spacer></v-spacer>
                    <!-- <v-btn flat icon color="blue"> -->
                      <v-icon style="color: black; font-size: 25px !important;">keyboard_arrow_right</v-icon>
                    <!-- </v-btn> -->
                  </v-layout>
                </v-flex>
              </div>
              <!-- web -->
              <div v-else-if="item.typeofmessage === 'web'" class="f-r chat_otherweb">
                <iframe width="300" height="400" style="visibility:visible;" frameborder='0' :src="item.message"></iframe>
              </div>
              <!-- official_template -->
              <v-card class="template_official f-r" v-else-if="item.typeofmessage === 'official_template'" style="width: 240px; height: auto;">
                <v-img aspect-ratio="1.5" :src="item.element.image" v-if="item.element.image !== 'http://203.151.50.40/static/img/default_profile/bot-white.png'" class="alligator-turtle"></v-img>
                <v-img aspect-ratio="1.5" :src="require('../assets/image_empty.png')" v-else class="alligator-turtle"></v-img>
                <v-layout>
                  <v-flex>
                    <p style="padding-top: 2px; padding-left: 5px;">
                      <font style="font-size: 1.5em; font-weight: bold;">{{ item.element.title }}</font><br />
                      <read-more style="padding-top: 1px; font-weight: bold; color:#878787;" more-str="อ่านเพิ่มเติม" :text="item.element.detail" less-str="แสดงน้อยลง" :max-chars="18"></read-more>
                    </p>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-flex
                  style="margin-top: 1em;"
                  v-for="(menu, i) in item.element.choice"
                  :key="i"
                >
                  <!-- <p style="text-align: center;">
                    <font style="font-size: 1.1em; font-weight: normal; color: #878787;">{{ menu.label }}</font>
                  </p>
                  <v-divider v-if="i !== 3"></v-divider> -->
                  <v-btn v-if="menu.type === 'file'" flat :style="checkbutton(menu.color,menu.background)" @click="btn_official_template(menu, item.tokenuser, item.tokenmessage)" :disabled="(menu.disable == '0')? false: true">
                    {{menu.label}}
                  </v-btn>
                  <v-btn v-else flat :style="checkbutton(menu.color,menu.background)" @click="btn_official_template(menu, item.tokenuser, item.tokenmessage)" disabled>
                    {{menu.label}}
                  </v-btn>
                </v-flex>
              </v-card>
              <!-- no type -->
              <div class="chat_other f-r" slot="activator" v-else>
                ข้อความนี้ไม่รองรับในเวอร์ชันนี้ {{item.typeofmessage}}
              </div>
              <v-layout align-end justify-start row fill-height v-if="item.typeofmessage !== 'unsend_message' && item.typeofmessage !== 'system_action_albums' && item.typeofmessage !== 'system_action_task' && item.typeofmessage !== 'system_action'">
                <span style="float: left; font-size: 11px;">{{timeMoment(item.timestamp)}} น.</span>
              </v-layout>
            </v-flex>
            <!--============ TYPE BOT =============-->
            <v-flex xs12 mr-3 mb-2 v-else-if="item.tokenuser == tokenuser">
              <!-- admin_nickname -->
              <!-- <div class="f-r"> -->
                <!-- <v-layout row wrap justify-end align-end class="mt-3">
                  <span v-if="item.admin_nickname" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 135px;">
                    {{item.admin_nickname}}
                  </span>
                  <span v-else></span>
                </v-layout> -->
              <!-- </div> -->
              <!-- message -->
              <div class="f-r chat_self" v-if="item.typeofmessage === 'message'" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')" @contextmenu.prevent="RightClickDialog($event,['mention', 'cancel', 'announce'], item)">
              </div>
              <!-- unsend_message -->
              <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 1vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'unsend_message'">
                <p class="boxother_unsend">
                  {{item.nickname}} ยกเลิกข้อความ
                </p>
              </v-flex>
              <!-- image -->
              <div class="f-r"  v-else-if="item.typeofmessage === 'image'" @contextmenu.prevent="RightClickDialog($event,['mention', 'cancel', 'announce'], item)">
                <!-- <img :src="item.message" height="200px" class="chat_selfimage" @click="zoom(item)"> -->
                <img :src="item.message" height="200px" class="chat_selfimage" @click="zoom(item)">
              </div>
              <!-- file -->
              <div class="f-r" v-else-if="item.typeofmessage === 'file' && (extension(item.file_name) === 'pdf' || extension(item.file_name) === 'media' || extension(item.file_name) === 'audio')" @contextmenu.prevent="RightClickDialog($event,['mention', 'cancel', 'announce'], item)">
                <v-flex xs12 v-if="extension(item.file_name) === 'pdf'" class="chat_selffile">
                  <v-layout row wrap>
                    <v-flex xs12 md12 sm12 lg12 xl12>
                      <v-card-media style="height: 95px; border-radius: 10px; cursor: pointer;" @click="zoomfile(item, false)">
                        <pdf
                        :src="item.message"
                        :page="1"
                        ref="myPdfComponent">
                        </pdf>
                      </v-card-media>
                    </v-flex>
                    <v-flex xs12 md12 sm12 lg12 xl12>
                      <div class="text2">{{item.file_name}}</div>
                    </v-flex>
                  </v-layout>
                  <v-divider style="margin-top: 10px;"></v-divider>
                  <v-layout row wrap align-center justify-end>
                    <v-btn flat icon color="blue" @click="loadfilepdf(item)" :loading="loadingpdf" :disabled="loadingpdf">
                      <v-icon style="color: black; font-size: 25px !important;">file_download</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-else-if="extension(item.file_name) === 'audio'" class="chat_selffile">
                  <audio controls style="width: 175px !important;">
                    <source :src="item.message" :type="'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                  </audio>
                  <v-flex xs12>
                    <div class="text2">{{item.file_name}}</div>
                  </v-flex>
                  <v-divider style="margin-top: 10px;"></v-divider>
                  <v-layout row wrap align-center justify-end>
                    <v-btn flat icon color="blue" @click="loadfilepdf(item)">
                      <v-icon style="color: black; font-size: 25px !important;" >file_download</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-else-if="extension(item.file_name) === 'media'" class="chat_selfvideo">
                  <video style="width: 177px !important; height: 130px !important;" controls disablePictureInPicture controlsList="nodownload noFullscreen">
                    <source :src="item.message" :type="'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                  </video>
                  <v-flex xs12>
                    <div class="text2">{{item.file_name}}</div>
                  </v-flex>
                  <v-divider style="margin-top: 5px;"></v-divider>
                  <v-layout row align-center justify-end>
                    <v-flex xs2>
                      <v-btn flat icon color="blue" @click="previewvideo(item)">
                        <v-icon style="color: black; font-size: 20px !important;">fas fa-expand</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs3>
                      <v-btn flat icon color="blue" @click="downloadURI(item)">
                        <v-icon style="color: black; font-size: 25px !important;">file_download</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-else>
                  <v-layout row wrap>
                    <v-flex xs6 md6 sm6 lg6 xl6>
                      <v-icon style="color: black; font-size: 60px !important; margin-top: 1vh; justify-content: center; display: flex;">{{extension(item.file_name)}}</v-icon>
                    </v-flex>
                    <v-flex xs6 md6 sm6 lg6 xl6>
                      <div class="textfile">{{item.file_name}}</div>
                    </v-flex>
                  </v-layout>
                  <v-divider style="margin-top: 10px;"></v-divider>
                  <v-layout row wrap align-center justify-end>
                    <v-btn flat icon color="blue" @click="loadfilepdf(item)">
                      <v-icon style="color: black; font-size: 25px !important;">file_download</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
              </div>
              <div class="f-r chat_selffile" v-else-if="item.typeofmessage === 'file'" @contextmenu.prevent="RightClickDialog($event,['mention', 'cancel', 'announce'], item)">
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs6 md6 sm6 lg6 xl6>
                      <v-icon style="color: black; font-size: 60px !important; margin-top: 1vh; justify-content: center; display: flex;">{{extension(item.file_name)}}</v-icon>
                    </v-flex>
                    <v-flex xs6 md6 sm6 lg6 xl6>
                      <div class="textfile">{{item.file_name}}</div>
                    </v-flex>
                  </v-layout>
                  <v-divider style="margin-top: 10px;"></v-divider>
                  <v-layout row wrap align-center justify-end>
                    <v-btn flat icon color="blue" @click="loadfilepdf(item)">
                      <v-icon style="color: black; font-size: 25px !important;">file_download</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
              </div>
              <!-- password_file -->
              <div class="f-r chat_selffile" style="height: auto !important;" v-else-if="item.typeofmessage === 'password_file'">
                <!-- @contextmenu.prevent="RightClickDialog($event,['mention', 'cancel', 'announce'], item)" -->
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs6 md6 sm6 lg6 xl6>
                      <v-icon style="color: black; font-size: 60px !important; margin-top: 1vh; justify-content: center; display: flex;">mdi-file-document</v-icon>
                    </v-flex>
                    <v-flex xs6 md6 sm6 lg6 xl6>
                      <div class="textfile">{{item.file_name}}</div>
                    </v-flex>
                  </v-layout>
                  <v-divider style="margin-top: 10px;"></v-divider>
                  <v-layout row wrap align-center justify-end class="mt-2">
                    <v-spacer></v-spacer>
                    <v-icon style="color: black; font-size: 25px !important;">mdi-lock</v-icon>
                    <!-- <v-btn flat icon color="blue" @click="loadfilepdf(item)" disabled>
                      <v-icon style="color: black; font-size: 25px !important;">file_download</v-icon>
                    </v-btn> -->
                  </v-layout>
                </v-flex>
              </div>
              <!-- video -->
              <div  v-else-if="item.typeofmessage === 'video' && (extension(item.file_name) === 'media' || extension(item.file_name) === 'audio')" class="f-r chat_selfvideo" @contextmenu.prevent="RightClickDialog($event,['mention', 'cancel', 'announce'], item)">
                <v-flex xs12 v-if="extension(item.file_name) === 'audio'">
                  <audio controls style="width: 175px !important;">
                    <source :src="item.message" :type="'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                  </audio>
                  <v-flex xs12>
                    <div class="text2">{{item.file_name}}</div>
                  </v-flex>
                  <v-divider style="margin-top: 10px;"></v-divider>
                  <v-layout row wrap align-center justify-end>
                    <v-btn flat icon color="blue" @click="loadfilepdf(item)">
                      <v-icon style="color: black; font-size: 25px !important;">file_download</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-else-if="extension(item.message) === 'media'">
                  <video style="width: 177px !important; height: 130px !important;" controls disablePictureInPicture controlsList="nodownload noFullscreen">
                    <source :src="item.message" :type="'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                  </video>
                  <v-flex xs12>
                    <div class="text2">{{item.file_name}}</div>
                  </v-flex>
                  <v-divider style="margin-top: 5px;"></v-divider>
                  <v-layout row align-center justify-end>
                    <v-flex xs2>
                      <v-btn flat icon color="blue" @click="previewvideo(item)">
                        <v-icon style="color: black; font-size: 20px !important;">fas fa-expand</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs3>
                      <v-btn flat icon color="blue" @click="downloadURI(item)">
                        <v-icon style="color: black; font-size: 25px !important;">file_download</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-else>
                  <vplayer
                  :playerOptions="{
                    type: 'application/x-mpegURL',
                    src: item.message,
                    preload: true,
                    autoplay: false,
                    isLoop: false,
                    playsinline: false,
                    poster: item.thumbnail,
                    controls: 'progress,current,durration,volume',
                    crossOrigin: false
                  }"
                    @onplay="play"
                  />
                  <v-flex xs12>
                    <div class="text2">{{item.file_name}}</div>
                  </v-flex>
                  <v-divider style="margin-top: 5px;"></v-divider>
                  <v-layout row wrap align-center justify-end>
                    <v-flex xs2>
                      <v-btn flat icon color="blue" @click="previewvideo(item)">
                        <v-icon style="color: black; font-size: 20px !important;">fas fa-expand</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs3>
                      <v-btn flat icon color="blue" @click="downloadURI(item)">
                        <v-icon style="color: black; font-size: 25px !important;">file_download</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </div>
              <!-- sticker -->
              <div class="f-r"  v-else-if="item.typeofmessage === 'sticker'" @contextmenu.prevent="RightClickDialog($event,['mention', 'cancel', 'announce'], item)">
                <img :src="item.file_name" class="chat_selfsticker">
              </div>
              <!-- contact -->
              <div class="f-r chat_selfcontact"  v-else-if="item.typeofmessage === 'contact'">
                <v-layout align-center justify-center row wrap>
                  <v-flex xs5 md5 sm5>
                    <v-layout align-center justify-center row wrap>
                      <v-avatar class="user-photo" >
                        <img v-if="item.pic_contact" :src="item.pic_contact" class="alligator-turtle">
                        <img v-else :src="require('../assets/robot1.png')" class="alligator-turtle">
                      </v-avatar>
                    </v-layout>
                  </v-flex>
                  <v-flex xs5 md5 sm5>
                    <v-layout align-center justify-center row wrap style="margin-top: 12px;">
                      <p class="text2">{{item.nickname_contact}}</p>
                    </v-layout>
                  </v-flex>
                  <v-flex xs2 md2 sm2>
                    <v-layout align-center justify-end row wrap>
                      <v-icon>navigate_next </v-icon>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </div>
              <!-- location -->
              <div class="chat_selfnote f-r" v-else-if="item.typeofmessage === 'location'">
                <v-layout align-center justify-center row wrap>
                  <v-flex xs2 md2 sm2>
                    <img :src="require('../assets/location.png')" style="height: 40px; width: 40px;">
                  </v-flex>
                  <v-flex xs10 md10 sm10 v-if="item.file_name !== ''">
                    <span>{{ item.file_name }}</span>
                  </v-flex>
                  <v-flex xs10 md10 sm10 v-else>
                    <span>{{ item.message }}</span>
                  </v-flex>
                </v-layout>
              </div>
              <!-- note -->
              <div class="f-r chat_selfnote" v-else-if="item.typeofmessage === 'note'">
                <v-flex xs12>
                  <v-layout row wrap align-start justify-start>
                    <v-flex xs6>
                      <span>{{item.message}}</span>
                    </v-flex>
                  </v-layout>
                  <v-divider style="margin-top: 10px;"></v-divider>
                  <v-layout row wrap align-center>
                    <span>โน๊ต</span>
                    <v-spacer></v-spacer>
                    <!-- <v-btn flat icon color="blue"> -->
                      <v-icon style="color: black; font-size: 25px !important;">keyboard_arrow_right</v-icon>
                    <!-- </v-btn> -->
                  </v-layout>
                </v-flex>
              </div>
              <!-- template -->
              <div slot="activator" v-else-if="item.typeofmessage === 'template'" class="boxfriendquestion f-r" style="overflow-x: scroll;overflow-y: hidden;display: flex; background: none; padding-top: 3px; margin-left: 5px; align-items: end;">
                <div v-for="(info_ans, index) in item.info_ans" :key="index">
                  <v-card style="margin-left: 10px; border-radius: 10px; width: 200px;">
                    <v-img :src="info_ans.image" aspect-ratio="2.75" v-if="info_ans.image"></v-img>
                    <v-card-title primary-title>
                      <div style="width: 176px;">
                        <h2 class="mb-0" style="color: #2562ae;">{{info_ans.title}}</h2>
                        <p style="font-size: 12px;color: #464c53;">{{info_ans.detail}}</p>
                        <!-- // <br  v-if="!info_ans.image"> -->
                        <v-divider light v-if="!info_ans.image"></v-divider>
                        <div v-for="(choice, index) in info_ans.choice" :key="index">
                          <v-btn v-if="choice.type === 'file' || choice.type === 'link'" flat color="primary"  style="text-transform: none; width: 100%;margin: 0; font-size: 13px;" @click="btn_answer_question(choice, item.tokenmessage)">
                            <v-icon v-if="choice.type === 'file'" style="font-size: 12px;">fas fa-download</v-icon> &nbsp;&nbsp; {{choice.label}}
                          </v-btn>
                          <v-btn v-else flat color="primary" style="text-transform: none; width: 100%;margin: 0;font-size: 13px;" @click="btn_answer_question(choice, item.tokenmessage)" disabled>
                            {{choice.label}}
                          </v-btn>
                        </div>
                      </div>
                    </v-card-title>
                  </v-card>
                </div>
              </div>
              <!-- web -->
              <div v-else-if="item.typeofmessage === 'web'" class="chat_selfweb f-r" slot="activator">
                <iframe width="300" height="400" style="visibility:visible;" frameborder='0' :src="item.message"></iframe>
              </div>
              <!-- approve message -->
              <p slot="activator" v-else-if="item.typeofmessage === 'approve_message'" style="width: 200px; " class="chat_selfapprove f-r">
                <v-card style="background-color: white; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                  <v-layout>
                    <v-flex xs12 sm12 md12 lg12 xl12>
                      <h3 style="color: #2562ae !important;">{{item.info_ans[0].title}}</h3>
                      <p style="color: #9d9d9d !important;">{{item.info_ans[0].short_detail}}</p>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions>
                    <span style="color: #b4b4b4 !important;"> คลิกดูรายละเอียด </span>
                    <v-spacer></v-spacer>
                    <v-icon style="color: #b4b4b4 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                  </v-card-actions>
                </v-card>
              </p>
              <!-- official_template -->
              <v-card class="chat_template_official f-r" v-else-if="item.typeofmessage === 'official_template'" style="width: 240px; height: auto;">
                <v-img aspect-ratio="1.5" :src="item.element.image" v-if="item.element.image !== 'http://203.151.50.40/static/img/default_profile/bot-white.png'" class="alligator-turtle"></v-img>
                <v-img aspect-ratio="1.5" :src="require('../assets/image_empty.png')" v-else class="alligator-turtle"></v-img>
                <v-layout>
                  <v-flex>
                    <p style="padding-top: 2px; padding-left: 5px;">
                      <font style="font-size: 1.5em; font-weight: bold;">{{ item.element.title }}</font><br />
                      <read-more style="padding-top: 1px; font-weight: bold; color:#878787;" more-str="อ่านเพิ่มเติม" :text="item.element.detail" less-str="แสดงน้อยลง" :max-chars="18"></read-more>
                    </p>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-flex
                  style="margin-top: 1em;"
                  v-for="(menu, i) in item.element.choice"
                  :key="i"
                >
                  <!-- <p style="text-align: center;">
                    <font style="font-size: 1.1em; font-weight: normal; color: #878787;">{{ menu.label }}</font>
                  </p>
                  <v-divider v-if="i !== 3"></v-divider> -->
                  <v-btn v-if="menu.type === 'file'" flat :style="checkbutton(menu.color,menu.background)" @click="btn_official_template(menu, item.tokenuser, item.tokenmessage)" :disabled="(menu.disable == '0')? false: true">
                    {{menu.label}}
                  </v-btn>
                  <v-btn v-else flat :style="checkbutton(menu.color,menu.background)" @click="btn_official_template(menu, item.tokenuser, item.tokenmessage)" disabled>
                    {{menu.label}}
                  </v-btn>
                </v-flex>
              </v-card>
              <!-- task_message -->
              <div class="f-r chat_selfnote" v-else-if="item.typeofmessage === 'task_message'" style="width: 240px; height: auto; background-color:#e0e0e0;">
                <div class="mb-1" v-if="item.message === 'create_task'">
                  <v-layout row>
                    <v-flex xs2>
                      <v-card v-if="item.priority === '1'" dark tile flat color="#b3493d" style="border-radius: 7px; width: 15px; height: 50px;">
                      </v-card>
                      <v-card v-if="item.priority === '2'" dark tile flat color="#f4c067" style="border-radius: 7px; width: 15px; height: 50px;">
                      </v-card>
                      <v-card v-if="item.priority === '3'" dark tile flat color="#a0a1a3" style="border-radius: 7px; width: 15px; height: 50px;">
                      </v-card>
                    </v-flex>
                    <v-flex>
                      <p style="padding-top: 0.5px;">
                        <font style="font-size: 1.5em; font-weight: bold; color: #3f516c; ">{{ item.project_name }}</font><br />
                        <font style="font-size: 1.1em; font-weight: bold; color: #657996;">{{ item.title }}</font>
                      </p>
                    </v-flex>
                  </v-layout>
                  <v-divider style="border-color: #31394121 !important; padding-bottom: 1px;"></v-divider>
                  <v-flex>
                    <p style="padding-top: 4px;">
                      <font style="font-size: 1.1em; font-weight: bold;" v-if=" item.detail !== ''">{{ item.detail }}</font>
                      <font style="font-size: 1.1em; font-weight: bold;" v-if=" item.detail === ''">-</font>
                      <br /><font style="font-size: 1.1em; font-weight: normal; color: #8297b6;">ผู้รับผิดชอบ:</font><br />
                      <v-flex
                        style="margin-left: 5px;"
                        v-for="(message, i) in item.task_info.assign"
                        :key="i"
                      >
                        <v-chip size="34px" style="background-color:#b3afaf;">
                          <v-avatar>
                            <v-img :src="message.path_pic" v-if="message.path_pic" class="alligator-turtle"></v-img>
                          </v-avatar>
                          <font style="font-size: 1.1em; font-weight: normal; padding-left: 3px;" class="long_text">{{ message.nickname }}</font>
                        </v-chip>
                      </v-flex>
                      <v-flex style="padding-top: 8px; text-align: center; margin-left: 6px; margin-top:15px; border: 1px solid white; border-radius: 5px; width: 80px; height: 40px;">
                        <font style="font-size: 1.1em; font-weight: normal; color: #989797;">{{ item.task_info.state.name }}</font>
                      </v-flex>
                    </p>
                  </v-flex>
                </div>
                <div class="mb-1" v-else>
                  <v-layout row>
                    <v-flex xs2>
                      <v-card v-if="item.priority === '1'" dark tile flat color="#b3493d" style="border-radius: 7px; width: 15px; height: 50px;">
                      </v-card>
                      <v-card v-if="item.priority === '2'" dark tile flat color="#f4c067" style="border-radius: 7px; width: 15px; height: 50px;">
                      </v-card>
                      <v-card v-if="item.priority === '3'" dark tile flat color="#a0a1a3" style="border-radius: 7px; width: 15px; height: 50px;">
                      </v-card>
                    </v-flex>
                    <v-flex>
                      <p style="padding-top: 0.5px;">
                        <font style="font-size: 1.5em; font-weight: bold; color: #3f516c" class="long_text">{{ item.project_name }}</font><br />
                        <font style="font-size: 1.1em; font-weight: bold; color: #657996" class="long_text">{{ item.title }}</font>
                      </p>
                    </v-flex>
                  </v-layout>
                  <v-divider style="border-color: #31394121 !important; padding-bottom: 1px;"></v-divider>
                  <v-flex>
                    <p style="padding-top: 4px;">
                      <font style="font-size: 1.1em; font-weight: bold;" v-if=" item.detail !== ''">{{ item.detail }}</font>
                      <font style="font-size: 1.1em; font-weight: bold;" v-if=" item.detail === ''">-</font>
                      <br /><font style="font-size: 1.1em; font-weight: normal; color: #8297b6;">ผู้รับผิดชอบ:</font><br />
                      <v-flex
                        style="margin-left: 5px;"
                        v-for="(message, i) in item.task_info.assign"
                        :key="i"
                      >
                        <v-chip size="34px" style="background-color:#b3afaf;">
                          <v-avatar>
                            <v-img :src="message.path_pic" v-if="message.path_pic" class="alligator-turtle"></v-img>
                          </v-avatar>
                          <font style="font-size: 1.1em; font-weight: normal; padding-left: 3px;" class="long_text">{{ message.nickname }}</font>
                        </v-chip>
                      </v-flex>
                    </p>
                  </v-flex>
                </div>
              </div>
              <!-- type carousel image -->
              <div v-else-if="item.typeofmessage === 'carousel'" class="f-r chat_carousel scrolling-wrapper-template" style="overflow-x: scroll;overflow-y: hidden; display: -webkit-inline-box; background: none;">
                <div v-for="(info_carousel, index) in item.elements" :key="index">
                  <v-card style="border-radius: 20px; width: 250px; margin-right: 10px;">
                    <v-img
                      :src="info_carousel.image"
                      :aspect-ratio="16/9"
                      v-if="info_carousel.image"
                      style="height: 250px;"
                    >
                      <v-layout v-if="info_carousel.type !== 'image'" row wrap align-end justify-center style="height: 250px;">
                        <v-btn disabled v-if="info_carousel.button" round color="#0000009c" dark>
                          <span class="text-transform">{{info_carousel.button}}</span>
                        </v-btn>
                      </v-layout>
                    </v-img>
                  </v-card>
                </div>
              </div>
              <!-- system_action -->
              <v-flex xl12 lg12 md12 sm12 style="margin-left: 2.2em; padding-right: 0px; margin-top: 1vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action'">
                <p class="boxother_unsend" v-if="item.message == 'invite'">
                  <span style="font-size: 13px;">
                  {{timeMoment(item.timestamp)}} น. <br />
                  {{item.nickname}} เชิญ {{item.file_name}}
                  </span>
                </p>
                <p class="boxother_unsend" v-else-if="item.message == 'active'">
                  <span style="font-size: 13px;">
                  {{timeMoment(item.timestamp)}} น. <br />
                  {{item.nickname}} เข้าร่วมกลุ่ม
                  </span>
                </p>
                <p class="boxother_unsend" v-else-if="item.message == 'kick'">
                  <span style="font-size: 13px;">
                  {{timeMoment(item.timestamp)}} น. <br />
                  {{item.nickname}} ลบ {{item.file_name}} ออกจากกลุ่ม
                  </span>
                </p>
                <p class="boxother_unsend" v-else-if="item.message == 'leave'">
                  <span style="font-size: 13px;">
                  {{timeMoment(item.timestamp)}} น. <br />
                  {{item.nickname}} ออกจากกลุ่ม
                  </span>
                </p>
              </v-flex>
              <!-- type other -->
              <div class="chat_self f-r" slot="activator" v-else>
                ข้อความนี้ไม่รองรับในเวอร์ชันนี้
              </div>
              <v-layout align-end justify-end column fill-height v-if="item.typeofmessage !== 'system_action' && item.typeofmessage !== 'unsend_message'">
                <v-tooltip top v-if="item.admin_nickname !== undefined">
                  <template v-slot:activator="{ on }">
                    <span v-on="on" v-if="item.admin_nickname" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 135px;">
                      {{item.admin_nickname}}
                    </span>
                    <span v-else></span>
                  </template>
                  <span>{{item.admin_nickname}}</span>
                </v-tooltip>
                <br>
                <div v-if="item.read !== undefined">
                  <v-icon  v-if="item.read.length > 1 && item.readnaja == 'True'" style="font-size: 14px; padding-right: 5px;">fas fa-check-circle</v-icon>
                </div>
                <!-- <v-icon  v-else-if="item.read.length < 1 && item.readnaja == 'false'" style="font-size: 14px; padding-right: 5px;">fas fa-check-circle</v-icon> -->
                <span style="float: right; font-size: 11px;">{{timeMoment(item.timestamp)}} น.</span>
              </v-layout>
            </v-flex>
          </v-layout>
          <!-- loading -->
          <div class="chat_self f-r" v-if="loading_file" style="width: 200px; height: 215px; margin-right: 14px;">
            <v-layout row wrap justify-center align-center style="height: 215px;">
              <v-progress-circular size="50" color="white" :indeterminate="loading_file"></v-progress-circular>
            </v-layout>
          </div>
          <!-- quick reply -->
          <v-date-picker v-model="dateselect" v-if="datepicker" :max="maxdate" :min="mindate" :landscape="true">
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="datepicker = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="senddate()">OK</v-btn>
          </v-date-picker>

          <v-time-picker v-model="timeselect" v-if="timepicker" :max="maxtime" :min="mintime" format="24hr" :landscape="true">
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="timepicker = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="sendtime()">OK</v-btn>
          </v-time-picker>
          <div class="scrolling-wrapper-quickreply">
            <a v-for="(item,index) in Quickreply" style="width: 100%; cursor: no-drop !important;" :key="index">
              <v-btn v-if="item.type == 'text'" round small class="quick_replydis" disabled>{{item.label}}</v-btn>
              <v-btn v-else-if="item.type == 'datepicker' || item.type == 'datetimepicker'" round small class="quick_replydis" disabled>
                <v-icon style="font-size: 12px;">fas fa-calendar-alt</v-icon> &nbsp;&nbsp; {{item.label}}
              </v-btn>
              <v-btn v-else-if="item.type == 'link'" round small class="quick_replydis" disabled>{{item.label}}</v-btn>
              <v-btn v-else-if="item.type == 'webview'" round small class="quick_replydis" disabled>{{item.label}}</v-btn>
              <v-btn v-else round small class="quick_replydis" disabled>{{item.label}}</v-btn>
            </a>
          </div>
        </v-flex>
        <!-- input text -->
        <v-alert
          style="background-color: rgba(179, 179, 180, 0.08) !important; height: 30px !important;"
          :value="alert"
          @click="close_alert()"
          outline
        >
          <!-- <p style="color: black;">{{ nickname_message }}:</p> -->
          <p style="color: black; margin-top: 1.2em; white-space: nowrap; width: 400px; overflow: hidden; text-overflow: ellipsis; text-align: left !important;" v-if="type_message === 'message'">{{ nickname_message }}:&nbsp;&nbsp;{{ get_message }}</p>
          <p style="color: black; margin-top: 1.2em; text-align: left !important;" v-else-if="type_message === 'image'">{{ nickname_message }}:&nbsp;&nbsp;ส่งรูป</p>
          <p style="color: black; margin-top: 1.2em; text-align: left !important;" v-else-if="type_message === 'file'">{{ nickname_message }}:&nbsp;&nbsp;ส่งไฟล์</p>
          <p style="color: black; margin-top: 1.2em; text-align: left !important;" v-else-if="type_message === 'contact'">{{ nickname_message }}:&nbsp;&nbsp;ส่งผู้ติดต่อ</p>
          <p style="color: black; margin-top: 1.2em; text-align: left !important;" v-else-if="type_message === 'location'">{{ nickname_message }}:&nbsp;&nbsp;ส่งสถานที่</p>
          <p style="color: black; margin-top: 1.2em; text-align: left !important;" v-else-if="type_message === 'sticker'">{{ nickname_message }}:&nbsp;&nbsp;ส่งสติ๊กเกอร์</p>
          <p style="color: black; margin-top: 1.2em; text-align: left !important;" v-else-if="type_message === 'note'">{{ nickname_message }}:&nbsp;&nbsp;สร้างโน๊ต</p>
          <p style="color: black; margin-top: 1.2em; text-align: left !important;" v-else-if="type_message === 'albums_message'">{{ nickname_message }}:&nbsp;&nbsp;สร้างอัลบั้ม</p>
          <p style="color: black; margin-top: 1.2em; text-align: left !important;" v-else-if="type_message === 'system_action_task'">{{ nickname_message }}:&nbsp;&nbsp;สร้างโปรเจค</p>
          <p style="color: black; margin-top: 1.2em; text-align: left !important;" v-else-if="get_message === 'active'">{{ nickname_message }}:&nbsp;&nbsp;{{ nickname_message }} เชิญ {{filename_message}}</p>
          <p style="color: black; margin-top: 1.2em; text-align: left !important;" v-else-if="get_message === 'invite'">{{ nickname_message }}:&nbsp;&nbsp;{{ nickname_message }} เข้าร่วมกลุ่ม</p>
          <p style="color: black; margin-top: 1.2em; text-align: left !important;" v-else-if="get_message === 'kick'">{{ nickname_message }}:&nbsp;&nbsp;{{ nickname_message }} ลบ {{filename_message}} ออกจากกลุ่ม</p>
          <p style="color: black; margin-top: 1.2em; text-align: left !important;" v-else-if="get_message === 'leave'">{{ nickname_message }}:&nbsp;&nbsp;{{ nickname_message }} ออกจากกลุ่ม</p>
          <p style="color: black; margin-top: 1.2em; text-align: left !important;" v-else>{{ nickname_message }}:&nbsp;&nbsp;{{ type_message }}</p>
        </v-alert>
        <v-alert
          class="scrolling-image"
          :value="preview_image"
          outline
        >
          <div style="overflow-x: hiddin; text-overflow: ellipsis; white-space: nowrap;">
            <span v-for="(img, key) in image" :key="key">
              <v-badge overlap style="margin-right: 1em; margin-top: 0.6em;"
                v-if='img.substring("data:image/".length, img.indexOf(";base64")) == "jpeg" || img.substring("data:image/".length, img.indexOf(";base64")) == "jpg" ||
                      img.substring("data:image/".length, img.indexOf(";base64")) == "gif" || img.substring("data:image/".length, img.indexOf(";base64")) == "png" ||
                      img.substring("data:image/".length, img.indexOf(";base64")) == "x-icon"'
              >
                <template v-slot:badge>
                  <span style="cursor:pointer; color: #e1dcdc;" v-show="image" @click="removeImage(key)"><v-icon>close</v-icon></span>
                </template>
                <v-layout row>
                  <v-flex>
                    <span>
                      <img style="height: 55px; width: 70px;  border-radius: 25%;" :src="img">
                    </span>
                  </v-flex>
                </v-layout>
                <!-- <img style="height: 55px; width: 70px;  border-radius: 30%;" :src="img"> -->
              </v-badge>
              <v-badge overlap style="margin-right: 1em; width: 100px;" v-else>
                <template v-slot:badge>
                  <span style="cursor:pointer; color: #e1dcdc;" v-show="image" @click="removeImage(key)"><v-icon>close</v-icon></span>
                </template>
                <v-layout row>
                  <v-flex>
                    <span style="color: #626262;">
                      <v-icon style="font-size: 45px !important; padding-bottom: 0.2em;">fas fa-file-alt</v-icon>
                    </span>
                    <h5 style="width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color:#6c6c6c;">{{filename(key)}}</h5>
                  </v-flex>
                </v-layout>
              </v-badge>
            </span>
            <span style="cursor:pointer; color: #9e9d9d;" @click="insertImage()">
              <v-icon style="font-size: 50px !important; padding-bottom: 0.2em;">add_photo_alternate</v-icon>
            </span>
          </div>
        </v-alert>
        <!-- <v-alert
          class="scrolling-image"
          :value="preview_file"
          outline
        >
          <div style="overflow-x: hiddin; text-overflow: ellipsis; white-space: nowrap;">
            <span v-for="(file, key) in filespreview" :key="key">
              <v-badge overlap style="margin-right: 1em; width: 100px;">
                <template v-slot:badge>
                  <span style="cursor:pointer; color: #e1dcdc;" v-show="file" @click="removeFile(key)"><v-icon>close</v-icon></span>
                </template>
                <v-layout row>
                  <v-flex>
                    <span style="color: #626262;">
                      <v-icon style="font-size: 45px !important; padding-bottom: 0.2em;">{{extensionIcon(file.name)}}</v-icon>
                    </span>
                    <h5 style="width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color:#6c6c6c;">{{file.name}}</h5>
                  </v-flex>
                </v-layout>
              </v-badge>
            </span>
            <span style="cursor:pointer; color: #9e9d9d;" @click="insertFile()">
              <v-icon style="font-size: 45px !important; padding-bottom: 0.2em; padding-left: 0.5em;">fas fa-file-medical</v-icon>
            </span>
          </div>
        </v-alert> -->
        <v-flex sm12 md12 lg12 xl12 style="height: 100%; border-width: thin; border-top-style: solid; border-color: #80808099; background-color: #698896;">
          <!-- #d3d3d3cc -->
            <v-layout align-center justify-center wrap v-if="statemember === 'active'">
              <v-flex xs12 sm12 md12>
                <v-layout align-center justify-center row style="margin-top: 10px; margin-right: 20px; margin-left: 20px;">
                  <v-menu
                    v-model="menu_other"
                    :close-on-content-click="false"
                    :nudge-width="190"
                    :nudge-top="20"
                    top
                    offset-y
                    content-class="my-menu-other"
                  >
                  <template v-slot:activator="{ on }">
                    <v-btn v-if="image.length === 0 && filepreview.length === 0" dark flat small icon v-on="on" style="margin-bottom: 30px; margin-right: 15px;" color="white">
                      <v-icon style="font-size: 30px !important;">add_circle_outline</v-icon>
                    </v-btn>
                    <v-btn v-else dark flat small icon disabled style="margin-bottom: 30px; margin-right: 15px;" color="white">
                      <v-icon style="font-size: 30px !important;">add_circle_outline</v-icon>
                    </v-btn>
                  </template>
                   <v-card tile style="text-transform: none !important;">
                      <v-card-text style="text-transform: none;">
                        <v-layout align-center justify-center row wrap>
                          <v-flex xs6 sm6 md6 lg6 xl6>
                            <v-layout row column justify-center align-center class="card-file" v-on:click="uppic()">
                              <v-btn small fab icon color="cyan">
                                <v-icon color="white">photo</v-icon>
                              </v-btn>
                              <p style="padding-top: 1vh;">รูปภาพ</p>
                            </v-layout>
                          </v-flex>
                          <v-flex xs6 sm6 md6 lg6 xl6>
                            <v-layout row column justify-center align-center class="card-file" v-on:click="upfile()">
                              <v-btn small fab icon color="teal">
                                <v-icon color="white">attach_file</v-icon>
                              </v-btn>
                              <p style="padding-top: 1vh;">ไฟล์</p>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                  <v-textarea
                    v-model="sendmsg"
                    solo
                    outline
                    no-resize
                    clear-icon="clear"
                    label="พิมพ์ข้อความ..."
                    type="text"
                    @click:clear="clearMessage"
                    @keydown.enter = "sendMessage(sendmsg)"
                    rows="3"
                    height="80"
                    box
                  ></v-textarea>
                  <v-btn flat icon v-if="sendmsg !== '' || image.length !== 0 || filepreview.length !== 0" v-on:click="sendMessage(sendmsg)" style="margin-bottom: 30px;">
                    <v-icon color="#00ceff" style="font-size: 30px !important;">fas fa-paper-plane</v-icon>
                  </v-btn>
                  <v-menu
                    v-model="menu_emoji"
                    :close-on-content-click="false"
                    :nudge-width="190"
                    :nudge-top="20"
                    top
                    offset-y
                    content-class="my-menu-emo"
                  >
                  <template v-slot:activator="{ on }">
                    <!-- <v-btn flat icon v-on="on" style="margin-bottom: 30px;">
                      <v-icon color="blue-grey darken-1" style="font-size: 28px !important;">fas fa-laugh-squint</v-icon>
                    </v-btn> -->
                    <v-btn v-on="on" flat small dark icon color="white" style="margin-bottom: 30px;">
                      <v-icon dark style="font-size: 30px !important;">emoji_emotions</v-icon>
                    </v-btn>
                  </template>
                  <v-card style="text-transform: none !important;">
                  <v-card-text row wrap style="padding-top: 2vh; text-transform: none;">
                    <v-tabs centered  v-model="activetapEmo" style="background: white !important; text-transform: none;" slot="extension">
                      <v-tab style="font-size: 20px; text-transform: none !important; overflow-y: hidden;" href="#tab-Emo" >
                        <p class="textemo mb-0">อีโมจิ</p>
                      </v-tab>
                      <v-tab style="font-size: 20px; text-transform: none !important; overflow-y: hidden;" href="#tab-Stick" >
                        <p class="textemo mb-0">สติกเกอร์</p>
                      </v-tab>
                    </v-tabs>
                    <v-tabs-items style="margin-top: 0.2vh;" v-model="activetapEmo">
                      <v-tab-item id="tab-Emo" style="text-transform: none;">
                        <div style="background: white !important;">
                          <v-tabs centered v-model="activeEmoji" style="background: white !important;" slot="extension">
                            <div style="width: 350px; justify-content: center; display: flex;">
                              <v-tab v-for="(emojiGroup, category) in emojiGroups" style="font-size: 20px;" :href="'#tab-'+ category" :key="category">
                                {{emojiGroup['smile']}}
                                {{emojiGroup['bear']}}
                                {{emojiGroup['soccer']}}
                                {{emojiGroup['house_with_garden']}}
                                {{emojiGroup['heart_decoration']}}
                              </v-tab>
                            </div>
                            </v-tabs>
                            <v-tabs-items  style="margin-top: 0.2vh;" v-model="activeEmoji">
                              <v-tab-item v-for="(emojiGroup, category) in emojiGroups" :id="'tab-'+category" style="height: 30vh;" :key="category" class="scrolling-wrapper">
                                <div class="emojis" style="font-size: 30px !important; cursor: pointer;">
                                  <span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName" @click="append(emoji)" :title="emojiName">{{ emoji }}</span>
                                </div>
                              </v-tab-item>
                            </v-tabs-items>
                        </div>
                      </v-tab-item>
                      <v-tab-item id="tab-Stick" style="height: 36.6vh; text-transform: none;">
                        <div style="background: white !important;">
                          <v-tabs show-arrows style="background: white !important;" v-model="activeSticker" slot="extension">
                            <div style="width: 350px; overflow-x: scroll;" class="scrolling-wrapper">
                              <v-tab style="font-size: 30px;" :href="'#tabsticker-'+item.token_sticker"  v-for="(item,index) in sticker" :key="index">
                                <img style="width: 30px;" :src="item.path_title">
                              </v-tab>
                            </div>
                          </v-tabs>
                          <v-tabs-items  style="margin-top: 0.2vh;" v-model="activeSticker">
                            <v-tab-item v-for="(item,index) in sticker" :id="'tabsticker-'+item.token_sticker" style="height: 250px;" :key="index" class="scrolling-wrapper">
                              <v-container wrap style="padding-top:  0px;">
                                <v-layout wrap>
                                  <v-flex sm4 md4 xs4 style=" justify-content: center;" v-for="(items,index) in item.list_sticker" :key="index">
                                    <v-layout style="justify-content: center;display: flex;text-align: center;">
                                      <img style="width: 80px; height: 80px; cursor: pointer;" :src="items.s3_name" @click="pushSticker(items.message)">
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-tab-item>
                          </v-tabs-items>
                          </div>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card-text>
                  </v-card>
                  </v-menu>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout  align-center justify-end wrap v-if="statemember !== 'active'">
              <v-flex xs12 sm12 md12>
                <v-layout  align-center justify-center row style="margin-top: 10px; margin-right: 20px; margin-left: 20px;">
                  <v-btn flat icon style="margin-bottom: 0px; margin-right: 15px;" disabled>
                    <v-icon color="blue-grey darken-1" style="font-size: 30px !important;">add_circle_outline</v-icon>
                  </v-btn>
                    <div style="height: 80px;
                      width: 100%;
                      border-radius: 20px;
                      border-style: solid;
                      border-color: #4d656f;
                      border-width: thin;
                      background-color: #00000042;">
                      <span style="float: left; padding-left: 20px; padding-top: 15px; color: #0000008a;">ไม่สามารถพิมพ์ข้อความได้...</span>
                    </div>
                    <v-btn flat icon style="margin-bottom: 0px;" disabled>
                      <v-icon color="blue-grey darken-1" style="font-size: 30px !important;">emoji_emotions</v-icon>
                    </v-btn>
                </v-layout>
              </v-flex>
            </v-layout>

            <!-- {{statemember}} -->
            <!-- <v-layout  align-center justify-end wrap v-if="statemember === 'active'">
              <v-flex xs12 sm12 md12>
                <v-layout  align-center justify-center row style="margin-top: 10px; margin-right: 20px; margin-left: 20px;">
                  <v-btn flat icon style="margin-bottom: 0px; margin-right: 15px;" disabled>
                    <v-icon color="blue-grey darken-1" style="font-size: 30px !important;">add_circle_outline</v-icon>
                  </v-btn>
                    <div style="height: 80px;
                      width: 100%;
                      border-radius: 20px;
                      border-style: solid;
                      border-color: #4d656f;
                      border-width: thin;
                      background-color: #00000042;">
                      <span style="float: left; padding-left: 20px; padding-top: 15px; color: #0000008a;">ไม่สามารถพิมพ์ข้อความได้ เนื่องจากในขณะนี้เปิดการตอบกลับอัตโนมัติอยู่</span>
                    </div>
                    <v-btn flat icon style="margin-bottom: 0px;" disabled>
                      <v-icon color="blue-grey darken-1" style="font-size: 30px !important;">emoji_emotions</v-icon>
                    </v-btn>
                </v-layout>
              </v-flex>
            </v-layout> -->

          </v-flex>
      </div>
    </v-layout>
    <!-- uppic upfile -->
    <div style="display:none;">
     <input id="insertpic" type="file" name="images[]" v-on:change="imagesInsert($event)" accept=".png, .jpg, .jpeg, .gif, .bmp, .wbmp" multiple>
     <input id="uploadpic" type="file" name="images[]" v-on:change="imagesAdd($event)" accept=".png, .jpg, .jpeg, .gif, .bmp, .wbmp" multiple>
     <!-- <input type="file" id="insertfileChat" v-on:change="imagesInsert($event)" multiple> -->
     <input type="file" id="uploadfileChat" v-on:change="imagesAdd($event)" multiple>
     <!-- <input type="file" id="insertfileChat" v-on:change="filesInsert($event)" multiple>
     <input type="file" id="uploadfileChat" v-on:change="fileAdd($event)" multiple> -->
     <!-- <input type="file" id="uploadpic" v-on:change="onimgSelected($event)" accept=".png, .jpg, .jpeg, .gif, .bmp, .wbmp" multiple/> -->
     <!-- <input type="file" id="uploadfileChat" v-on:change="onFileSelected" /> -->
    </div>
    <!-- tab other -->
    <!-- <div style="display: none;">
      <v-menu v-if="statemember=='active'" v-model="sheetother" id="tabother" :close-on-content-click="false" content-class="my-menu-other">
        <v-card tile style="text-transform: none !important;">
          <v-card-text style="padding-top: 8vh; text-transform: none; height: 200px;">
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 md4 sm4>
                <v-layout align-center justify-center wrap column>
                    <v-icon color="blue-grey" style="font-size: 70px !important;" v-on:click="uppic()">photo</v-icon>
                  </v-btn>
                  <p style="padding-top: 2vh; padding-right: 5vh;">รูปภาพ</p>
                </v-layout>
              </v-flex>
              <v-flex xs4 md4 sm4>
                <v-layout align-center justify-center column wrap>
                    <v-icon color="blue-grey" style="font-size: 70px !important;" v-on:click="upfile()">attach_file</v-icon>
                  <p style="padding-top: 2vh; padding-right: 4vh;">ไฟล์</p>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-menu>
    </div> -->
    <!-- tab sticker -->
    <div style="display: none;">
      <!-- <v-menu v-if="statemember=='active'" v-model="sheetsticker" id="tabsticker" :close-on-content-click="false" content-class="my-menu-emo">
        <v-card style="text-transform: none !important;">
          <v-card-text row wrap style="padding-top: 2vh; text-transform: none;">
            <v-tabs centered  v-model="activetapEmo" style="background: white !important; text-transform: none;" slot="extension">
              <v-tab style="font-size: 20px; text-transform: none !important; overflow-y: hidden;" href="#tab-Emo" >
                <p class="textemo">อีโมจิ</p>
              </v-tab>
              <v-tab style="font-size: 20px; text-transform: none !important; overflow-y: hidden;" href="#tab-Stick" >
                <p class="textemo">สติกเกอร์</p>
              </v-tab>
            </v-tabs>
            <v-tabs-items  style="margin-top: 0.2vh;" v-model="activetapEmo">
              <v-tab-item id="tab-Emo" style="text-transform: none;">
                 <div style="background: white !important;">
                  <v-tabs centered v-model="activeEmoji" style="background: white !important;" slot="extension">
                      <v-tab v-for="(emojiGroup, category) in emojiGroups" style="font-size: 20px;" :href="'#tab-'+ category" :key="category">
                        {{emojiGroup['smile']}}
                        {{emojiGroup['bear']}}
                        {{emojiGroup['soccer']}}
                        {{emojiGroup['house_with_garden']}}
                        {{emojiGroup['heart_decoration']}}
                      </v-tab>
                      </v-tabs>
                    <v-tabs-items  style="margin-top: 0.2vh;" v-model="activeEmoji">
                      <v-tab-item v-for="(emojiGroup, category) in emojiGroups" :id="'tab-'+category" style="height: 30vh;" :key="category" class="scrolling-wrapper">
                        <div class="emojis" style="font-size: 30px !important;">
                          <span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName" @click="append(emoji)" :title="emojiName">{{ emoji }}</span>
                        </div>
                      </v-tab-item>
                    </v-tabs-items>
                </div>
              </v-tab-item>
              <v-tab-item id="tab-Stick" style="height: 36.6vh;  text-transform: none;">
                <div style="background: white !important;">
                  <v-tabs centered  style="background: white !important;" v-model="activeSticker" slot="extension">
                      <v-tab style="font-size: 30px;" :href="'#tabsticker-'+item.token_sticker"  v-for="(item,index) in sticker" :key="index">
                        <img style="width: 30px;" :src="item.path_title">
                      </v-tab>
                    </v-tabs>
                    <v-tabs-items  style="margin-top: 0.2vh;" v-model="activeSticker">
                      <v-tab-item v-for="(item,index) in sticker" :id="'tabsticker-'+item.token_sticker" style="height: 180px;" :key="index" class="scrolling-wrapper">
                        <v-container wrap style="padding-top:  0px;">
                          <v-layout wrap>
                            <v-flex sm4 md4 xs4 style=" justify-content: center;" v-for="(items,index) in item.list_sticker" :key="index">
                              <v-layout style=" justify-content: center;display: flex;text-align: center;">
                                <img style="width: 80px; height: 80px; cursor: pointer;" :src="items.s3_name" @click="pushSticker(items.message)">
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-tab-item>
                    </v-tabs-items>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>
        </v-menu> -->
        <InforfriendDialogMobile :inforfrienddialog="inforfrienddialog" @closeInforfriend="closeInforfriend" :tokeninforfriend="tokeninforfriend"></InforfriendDialogMobile>
        <ChatlayoutDialog :chatdialog_image="chatdialog_image" :infor_image="infor_image" @closeImagedialog="closeImagedialog"></ChatlayoutDialog>
        <ChatlayoutVideo :chatdialog_video="chatdialog_video" :infor_video="infor_video" @closeVideodialog="closeVideodialog"></ChatlayoutVideo>
        <!-- <ShowImageDialog :dialogshowimage="dialogshowimage" :DetailImage="DetailImage" @closeDialogShowImage="closeDialogShowImage"/> -->
      </div>
  </div>
</template>
<script>
import pdf from 'vue-pdf'
import { Momenttime, Decode } from '@/services'
import { sync } from 'vuex-pathify'
import { VueContext } from 'vue-context'
import 'vue-context/dist/css/vue-context.css'
import InforfriendDialogMobile from '@/components/dialog/InforfriendDialogMobile'
import ChatlayoutDialog from '@/components/dialog/ChatlayoutDialog_test'
import ChatlayoutVideo from '@/components/dialog/ChatlayoutVideo'
import { vplayer } from 'vue-hls-player'
// import ShowImageDialog from '@/components/dialog/ShowImageDialog'
// import ShowImageDialog from '@/components/dialog/ShowImageDialog'
var _ = require('lodash')
const emojiGroups = require('../emoji/emoji.json')
export default {
  data: () => ({
    src: '',
    numPages: '',
    status_admin: '',
    status_admin_old: '',
    status_admin_list: [
      { text: 'ปกติ', value: '', color: '#7C7D81' },
      { text: 'รอแอดมิน', value: 'waiting', color: '#E28800' },
      { text: 'แอดมิน', value: 'admin', color: '#0B7A09' }
    ],
    state_webhook: false,
    loading_file: false,
    infor_image: {},
    DetailImage: {},
    dialogshowimage: false,
    menu_other: false,
    menu_emoji: false,
    datepicker: false,
    timepicker: false,
    maxdate: '',
    mindate: '',
    maxtime: '',
    mintime: '',
    dateselect: '',
    timeselect: '',
    infodata: '',
    Quickreply: [],
    loading: false,
    tokenrooomSelect: '',
    infofriend: {},
    marker: true,
    chatlogsFlex: '',
    sendmsg: '',
    statemember: '',
    progressLoadChat: false,
    sheetother: false,
    sheetsticker: false,
    statusload: false,
    selectFile: null,
    activeEmoji: null,
    activeSticker: null,
    activetapEmo: null,
    emojiGroups,
    listmessage: [],
    sticker: [
      { 'list_sticker': [] }
    ],
    nicknameSend: '',
    filenameSend: '',
    timeSend: '',
    picSend: '',
    dateSend: '',
    tokenmsgSend: '',
    pathSend: '',
    typeuserSend: '',
    typeuser: '',
    filepdf: '',
    loadingpdf: false,
    markread: false,
    mark: [],
    inforfrienddialog: false,
    tokeninforfriend: '',
    tokenuser: '',
    chatdialog_image: false,
    token_image: '',
    check_scroll: '',
    alert: false,
    filename_message: '',
    nickname_message: '',
    get_message: '',
    type_message: '',
    time_send: '',
    get_data: [],
    preview_image: false,
    images: [],
    image: [],
    preview_file: false,
    filespreview: {},
    filepreview: [],
    chatdialog_video: false,
    infor_video: {},
    imageArray: [],
    imageDrag: [],
    token_admin: '',
    rightclickdialog: false,
    SelectedMessageDetail: {},
    ListMenuRightClick: [],
    member_inroom: 0
  }),
  components: {
    vplayer,
    pdf,
    InforfriendDialogMobile,
    ChatlayoutDialog,
    ChatlayoutVideo,
    VueContext
    // ShowImageDialog
  },
  computed: {
    icon () {
      return this.icons[this.iconIndex]
    },
    ...sync('*')
  },
  props: {
    source: String
  },
  watch: {
    filepdf () {
      // console.log(this.filepdf)
      this.src = pdf.createLoadingTask(this.filepdf)
      // console.log(this.src)
      this.src.promise.then(pdf => {
        // console.log(pdf)
        this.numPages = pdf.numPages
        // console.log(this.numPages)
      })
    },
    socket_official_status (data) {
      // console.log(data)
      this.status_admin = data.status
      var listchat = JSON.parse(localStorage.getItem('listchat'))
      var me = this
      var index = _.findIndex(listchat, function (o) { return o.tokenroom === me.tokenrooomSelect })
      if (index !== -1) {
        listchat[index].official_status = data.status
      }
      // console.log(listchat[index])
      localStorage.setItem('listchat', JSON.stringify(listchat))
      localStorage.setItem('listchat_length', listchat.length)
    },
    // status_admin(){
    //   console.log(this.status_admin.value)
    //   this.$swal({
    //     html: `คุณต้องการเปลี่ยนสถานะเป็น <span style="font-weight:bold; color:${this.status_admin.color};">"${this.status_admin.text}"</span> ใช่หรือไม่?`,
    //     type: 'warning',
    //     showCancelButton: true,
    //     confirmButtonColor: '#2562af',
    //     cancelButtonColor: '#9f9f9f',
    //     confirmButtonText: 'ตกลง',
    //     cancelButtonText: 'ยกเลิก',
    //     confirmButtonClass: 'btn btn-danger',
    //     cancelButtonClass: 'btn btn-success',
    //     buttonsStyling: true,
    //     showCloseButton: true,
    //     reverseButtons: true
    //   }).then((result) => {
    //     if (result.value) {
    //       this.axios.post(process.env.VUE_APP_API_STATUS_ADMIN, {
    //         tokenroom: this.tokenrooomSelect,
    //         tokenuser:this.token_admin,
    //         status:this.status_admin.value
    //       }).then((response) => {
    //         // console.log(response.data)
    //         if (response.data.status === 'success') {
    //           this.$swal({
    //             html:`เปลี่ยนสถานะเป็น <span style="font-weight:bold; color:${this.status_admin.color};"> "${this.status_admin.text}"</span> สำเร็จ`,
    //             type : 'success'
    //           })

    //         }
    //       }).catch(error => {
    //         console.log(error)
    //       })
    //     }
    //   })
    // },
    socketmarkread (data) {
      // for (var i = 0; i < data.listtokenmessage.length; i++) {
      //   var indexmsg = []
      //   indexmsg = _.findIndex(this.listmessage, function (o) { return o.tokenmessage === data.listtokenmessage[i] })
      //   if(this.listmessage[indexmsg] != undefined) {
      //     this.listmessage[indexmsg].read = [ this.listfriend[0].tokenuser, this.tokenuser ]
      //   }
      // }
    },
    socket_kickmember (data) {
      // console.log(data)
      if (data.tokenroom === this.$route.params.roomid) {
        this.statemember = 'leave'
      }
    },
    socketinvite_group (data) {
      // console.log(data)
      if (data.tokenroom === this.$route.params.roomid) {
        this.statemember = 'active'
      }
    },
    socket_unsendmessage (data) {
      // console.log(data)
      if (data.tokenroom === this.$route.params.roomid) {
        var indexid = _.findIndex(this.listmessage, function (o) {
          return o.tokenmessage === data.tokenmessage
        })
        var mentiontokenmessage = this.listmessage[indexid].tokenmessage
        var indexmentionmsg = _.findIndex(this.listmessage, function (o) {
          return o.file_name === mentiontokenmessage
        })
        if (indexmentionmsg === -1) {
          this.listmessage[indexid].typeofmessage = 'unsend_message'
        } else {
          this.listmessage[indexid].typeofmessage = 'unsend_message'
          this.listmessage[indexmentionmsg].source_message.typeofmessage = 'unsend_message'
        }
      }
    },
    socketmessage (data) {
      // console.log(data)
      this.filename_message = this.socketmessage.file_name
      this.nickname_message = this.socketmessage.nickname
      this.get_message = this.socketmessage.message
      this.type_message = this.socketmessage.typeofmessage
      this.getMessageSocket(this.socketmessage)
      this.Quickreply = ''
      // console.log(JSON.parse(localStorage.getItem('listchat')))
      // เวลามี bot ส่งข้อความหาคน ต้องไปอัพเดทข้อความล่าสุดตรง listchat
      var listchat = JSON.parse(localStorage.getItem('listchat'))
      var index = _.findIndex(listchat, function (o) { return o.tokenroom === data.tokenroom })
      // console.log(index)
      // console.log(listchat[index])
      if (data.tokenuser === this.$route.params.id) {
        // console.log(data.tokenuser)
        // console.log(listchat)
        if (index === -1) {
          listchat[0].message = data.message
          listchat[0].timestamp = data.timestamp
          listchat[0].official_status = this.status_admin_old
          // เรียงตาม timestamp
          listchat = _.sortBy(listchat, ['timestamp']).reverse()
          localStorage.setItem('listchat', JSON.stringify(listchat))
        } else {
          var datachat = listchat[index]
          // console.log(listchat[index])
          // console.log(datachat)
          _.pullAt(listchat, index) // ลบ listchat เดิม
          listchat.unshift({
            count_read: 0,
            timestamp: data.timestamp,
            file_name: data.file_name,
            tokenroom: datachat.tokenroom,
            tokenuser: datachat.tokenuser,
            type: datachat.type,
            typeofmessage: data.typeofmessage,
            state: 'active',
            message: data.message,
            name: datachat.name,
            picture: datachat.picture,
            official_status: this.status_admin_old
          })
          // console.log(listchat)
          localStorage.setItem('listchat', JSON.stringify(listchat))
        }
      } else {
        // console.log('socket message chat layout')
        this.axios.post(process.env.VUE_APP_API_GOAPI + '/api/v4/getRoomDataForOfficial', { bot_id: this.$route.params.id, tokenroom: data.tokenroom }).then((response) => {
          // console.log(response.data)
          if (response.data !== 'room_or_bot_id_not_found') {
            if (index !== -1) {
              listchat[index].message = data.message
              listchat[index].timestamp = data.timestamp
              listchat[index].official_status = this.status_admin_old
              // เรียงตาม timestamp
              listchat = _.sortBy(listchat, ['timestamp']).reverse()
              // console.log(listchat)
              // set listchat ล่าสุดที่ได้จาก socket
              localStorage.setItem('listchat', JSON.stringify(listchat))
            } else {
              // console.log('test socket message')
              _.pullAt(listchat, index) // ลบ listchat เดิม
              listchat.unshift({
                count_read: 0,
                timestamp: data.timestamp,
                name: data.nickname,
                file_name: data.file_name,
                picture: data.path_pic,
                tokenroom: data.tokenroom,
                tokenuser: data.tokenuser,
                type: data.type,
                typeofmessage: data.typeofmessage,
                state: 'active',
                message: data.message,
                official_status: this.status_admin_old
              })
              // console.log(listchat)
              localStorage.setItem('listchat', JSON.stringify(listchat))
            }
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
    socketquickreply (data) {
      // console.log(data)
      if (data.tokenroom === this.$route.params.roomid) {
        // this.getreply()
        this.Quickreply = data.quick_reply
      }
    },
    socketdisablequickreply (data) {
      if (data.tokenroom === this.$route.params.roomid) {
        this.Quickreply = ''
      }
    },
    sheetsticker () {
      if (this.sheetsticker === true) {
        // this.chatlogsFlex = 'height:25vh !important;'
      } else {
        // this.chatlogsFlex = 'height:100% !important;'
      }
    },
    sheetother () {
      if (this.sheetother === true) {
        // this.chatlogsFlex = 'height:25vh !important;'
      } else {
        // this.chatlogsFlex = 'height:98% !important;'
      }
    }
  },
  mounted () {
    // console.log(this.status_admin)
    // console.log(this.listmessage)
  },
  created () {
    // console.log(this.status_admin)
    this.tokenrooomSelect = this.$route.params.roomid
    this.tokenuser = this.$route.params.id
    this.token_admin = Decode.decodeToken(localStorage.getItem('tokenuser'))
    // console.log(this.token_admin)
    // console.log(Decode.decodeToken(localStorage.getItem('tokenuser')))
    this.getMessageFirst('')
    this.getdataroom()
    this.getliststicker()
    this.getreply()
    this.check_block_webhook()
  },
  methods: {
    setStateWithStatus () {
      this.$swal({
        html: `คุณต้องการ <b style="font-weight:bold; color: #2562af;">เปิด</b> หรือ <b style="font-weight:bold; color:#cc0000;"> ปิด </b> การตอบกลับอัตโนมัติ?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#cc0000',
        confirmButtonText: 'เปิด',
        cancelButtonText: 'ปิด',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        // showCloseButton: true,
        reverseButtons: false
      }).then((result) => {
        if (result.value) {
          // เปิด webhook
          // ยืนยันเปลี่ยนสถานะแอดมิน
          this.changeStatusOfficial(false, '#2562af')
        } else {
          // ปิด webhook
          this.changeStatusOfficial(true, '#cc0000')
        }
      })
    },
    changeStatusOfficial (state, colorState) {
      this.setStateWebhook(state)
      var color = this.status_admin.color
      var text = this.status_admin.text
      var value = this.status_admin.value
      var stateText = ''
      if (state) {
        stateText = 'ปิด'
      } else {
        stateText = 'เปิด'
      }
      this.axios.post(process.env.VUE_APP_API_STATUS_ADMIN, {
        tokenroom: this.tokenrooomSelect,
        tokenuser: this.token_admin,
        status: value,
        bot_id: this.tokenuser
      }).then((response) => {
        // console.log(response.data)
        console.log(`set status admin -> ${value}: ${response.data.status}`)
        if (response.data.status === 'success') {
          this.$swal({
            html: `เปลี่ยนสถานะเป็น <span style="font-weight:bold; color:${color};"> "${text}"</span> และ <span style="font-weight:bold; color: ${colorState};"> "${stateText}"</span> การตอบกลับอัตโนมัติสำเร็จ`,
            type: 'success'
          })
          this.status_admin_old = value
          // console.log(this.status_admin_old)
          // console.log(JSON.parse(localStorage.getItem('listchat')))
          var listchat = JSON.parse(localStorage.getItem('listchat'))
          var me = this
          var index = _.findIndex(listchat, function (o) { return o.tokenroom === me.tokenrooomSelect })
          // console.log(listchat[index])
          if (index !== -1) {
            listchat[index].official_status = this.status_admin_old
            localStorage.setItem('listchat', JSON.stringify(listchat))
            localStorage.setItem('listchat_length', listchat.length)
          }
        }
      }).catch(error => {
        console.log(error)
      })
      // // console.log(state)
      // var color = this.status_admin.color
      // var text = this.status_admin.text
      // var value = this.status_admin.value
      // var htmlText = ''
      // var stateText = ''
      // if (state) {
      //   stateText = 'ปิด'
      // } else {
      //   stateText = 'เปิด'
      // }
      // // console.log(value)
      // // ถ้า official_status เป็นสถานะ ปกติ เปิด webhook, ถ้าเป็น waiting, admin ปิด webhook
      // htmlText = `คุณต้องการเปลี่ยนสถานะเป็น <span style="font-weight:bold; color:${this.status_admin.color};">"${this.status_admin.text}"</span> <br> <p>และ<b style="font-weight:bold; color:#cc0000;"> ${stateText} </b>การตอบกลับอัตโนมัติใช่หรือไม่?</p>`
      // this.$swal({
      //   title: `ยืนยันข้อมูล`,
      //   html: htmlText,
      //   type: 'warning',
      //   showCancelButton: true,
      //   confirmButtonColor: '#2562af',
      //   cancelButtonColor: '#9f9f9f',
      //   confirmButtonText: 'ตกลง',
      //   cancelButtonText: 'ยกเลิก',
      //   confirmButtonClass: 'btn btn-danger',
      //   cancelButtonClass: 'btn btn-success',
      //   buttonsStyling: true,
      //   showCloseButton: true,
      //   reverseButtons: true
      // }).then((result) => {
      //   if (result.value) {
      //     console.log(`state webhook: ${this.state_webhook}`)
      //     // set webhook ก่อนเปลี่ยนสถานะ
      //     this.setStateWebhook(state)
      //     this.axios.post(process.env.VUE_APP_API_STATUS_ADMIN, {
      //       tokenroom: this.tokenrooomSelect,
      //       tokenuser: this.token_admin,
      //       status: value,
      //       bot_id: this.tokenuser
      //     }).then((response) => {
      //       // console.log(response.data)
      //       console.log(`set status admin -> ${value}: ${response.data.status}`)
      //       if (response.data.status === 'success') {
      //         this.$swal({
      //           html: `เปลี่ยนสถานะเป็น <span style="font-weight:bold; color:${color};"> "${text}"</span> และ <span style="font-weight:bold; color: #cc0000;"> "${stateText}"</span> การตอบกลับอัตโนมัติสำเร็จ`,
      //           type: 'success'
      //         })
      //         this.status_admin_old = value
      //         // console.log(this.status_admin_old)
      //         // console.log(JSON.parse(localStorage.getItem('listchat')))
      //         var listchat = JSON.parse(localStorage.getItem('listchat'))
      //         var me = this
      //         var index = _.findIndex(listchat, function (o) { return o.tokenroom === me.tokenrooomSelect })
      //         // console.log(listchat[index])
      //         if (index !== -1) {
      //           listchat[index].official_status = this.status_admin_old
      //           localStorage.setItem('listchat', JSON.stringify(listchat))
      //           localStorage.setItem('listchat_length', listchat.length)
      //         }
      //       }
      //     }).catch(error => {
      //       console.log(error)
      //     })
      //   } else {
      //     this.status_admin = this.status_admin_old
      //   }
      // })
    },
    btn_official_template (item, tokenuserBot, tokenmessage) {
      if (item.type === 'file') {
        this.downloadFileMenu(item)
      }
    },
    checkbutton (color, bng) {
      var text = {
        'text-transform': 'none',
        'width': '100%',
        'margin': '0',
        'font-size': '13px',
        'margin-top': '5px',
        'border-radius': '20px'
      }
      // [choice.color]? ('color': choice.color):('color':'black')
      if (color) {
        text['color'] = color
      } else {
        text['color'] = 'black'
      }
      if (bng) {
        text['background'] = bng
      } else {
        text['background'] = 'none'
      }
      return text
    },
    btn_answer_question (item, tokenmessage) {
      // console.log(item)
      // if (item.type === 'link' || item.type === 'webview') {
      //   this.check_get_accesstoken(item)
      // } else if (item.type === 'file') {
      //   this.downloadFileMenu(item)
      // } else if (item.type === 'link_market') {
      //   this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
      // } else if (item.type === 'ekyc') {
      //   this.ans_ekyc_template(item)
      // }
      if (item.type === 'file') {
        this.downloadFileMenu(item)
      } else if (item.type === 'link') {
        window.open(item.url, '_blank')
      }
    },
    downloadFileMenu (item) {
      var name = item.file.split('/')[item.file.split('/').length - 1]
      this.axios.get(item.file, {
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
      })
    },
    handleClickTest (e) {
      // console.log(e)
      const username = e.target.innerHTML.substring(1)
      // console.log(e.target.innerHTML.substring(1))
      const myUser = localStorage.name
      if (username !== myUser) {
        this.listfriend.forEach(freind => {
          const rex = /[\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{1f004}\u{1f0cf}\u{1f170}-\u{1f171}\u{1f17e}-\u{1f17f}\u{1f18e}\u{3030}\u{2b50}\u{2b55}\u{2934}-\u{2935}\u{2b05}-\u{2b07}\u{2b1b}-\u{2b1c}\u{3297}\u{3299}\u{303d}\u{00a9}\u{00ae}\u{2122}\u{23f3}\u{24c2}\u{23e9}-\u{23ef}\u{25b6}\u{23f8}-\u{23fa}]/ug
          var x = username.replace(rex, match => `[e-${match.codePointAt(0).toString(16)}]`)
          var y = freind.name.replace(rex, match => `[e-${match.codePointAt(0).toString(16)}]`)

          if (x.includes(y)) {
            // console.log(freind)
            // const tokenUser = freind.tokenuser
            this.detailFriendDialog(freind)
          }
        })
      } else {
        // var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
        // this.detailFriendDialog(decoded.tokenuser)
      }
    },
    RightClickDialog ($event, list, item) {
      // console.log(item)
      // console.log($event)
      this.ListMenuRightClick = []
      if (this.statemember === 'active') {
        if (list.includes('cancel')) {
          this.ListMenuRightClick.push({ message: `ยกเลิกข้อความ`, methods: 'cancel' })
        }
        this.rightclickdialog = true
        this.SelectedMessageDetail = item
        this.$refs.menu.open($event)
        // console.log(this.SelectedMessageDetail)
      }
    },
    SelectMenuRightClick (selected) {
      // console.log(selected)
      if (selected === 'add_albums') {
        this.add_image_albums()
      } else if (selected === 'mention') {
        this.mention_message()
      } else if (selected === 'cancel') {
        this.unsendmessage()
      } else if (selected === 'sendmail') {
        this.sendemail()
      } else if (selected === 'announce') {
        this.announce_msg()
      } else if (selected === 'cancel_announce') {
        this.cancel_announce()
      }
    },
    unsendmessage () {
      this.rightclickdialog = false
      this.$swal({
        text: 'คุณต้องการยกเลิกข้อความนี้ใช่หรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.VUE_APP_API_IMAGE + '/delete_message', {
            tokenuser: this.tokenuser,
            tokenmessage: this.SelectedMessageDetail.tokenmessage
          }).then((response) => {
            if (response.data['status'] === 'success') {
              this.$swal('', 'ยกเลิกข้อความสำเร็จ', 'success')
            } else {
              this.axios.post(process.env.VUE_APP_API_OFFICIAL + `/unsend-broadcast`, {
                bot_id: this.tokenuser,
                tokenmessage: this.SelectedMessageDetail.tokenmessage
              }).then((response) => {
                // console.log(response.data)
                var me = this
                var indexid = _.findIndex(this.listmessage, function (o) {
                  return o.tokenmessage === me.SelectedMessageDetail.tokenmessage
                })
                this.listmessage[indexid].typeofmessage = 'unsend_message'
                this.$swal('', 'ยกเลิกข้อความสำเร็จ', 'success')
              }).catch(error => {
                console.log(error.response)
              })
            }
          }).catch(error => {
            console.log(error.response)
          })
        }
      })
    },
    check_block_webhook () {
      this.axios.post(process.env.VUE_APP_API_CHECK_WEBHOOK, {
        tokenroom: this.tokenrooomSelect
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.state_webhook = response.data.block
        }
      }).catch(error => {
        console.log(error)
      })
    },
    block_webhook () {
      console.log('block webhook')
      this.$swal({
        title: 'คุณต้องการปิดการตอบข้อความอัตโนมัติใช่หรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '',
        cancelButtonColor: '',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.VUE_APP_API_SWITCH_WEBHOOK, {
            tokenroom: this.tokenrooomSelect,
            block: true
          }).then((response) => {
            // console.log(response.data)
            if (response.data.status === 'success') {
              this.$swal('', 'ปิดการตอบกลับข้อความอัตโนมัติสำเร็จ', 'success')
              this.state_webhook = true
              // this.setOfficialStatus('waiting')
            }
          }).catch(error => {
            console.log(error)
          })
        }
      })
    },
    unblock_webhook () {
      console.log('unblock webhook')
      this.$swal({
        title: 'คุณต้องการเปิดการตอบข้อความอัตโนมัติใช่หรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '',
        cancelButtonColor: '',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.VUE_APP_API_SWITCH_WEBHOOK, {
            tokenroom: this.tokenrooomSelect,
            block: false
          }).then((response) => {
            // console.log(response.data)
            if (response.data.status === 'success') {
              this.$swal('', 'เปิดการตอบกลับข้อความอัตโนมัติสำเร็จ', 'success')
              this.state_webhook = false
              // this.setOfficialStatus('')
            }
          }).catch(error => {
            console.log(error)
          })
        }
      })
    },
    setOfficialStatus (value) {
      this.axios.post(process.env.VUE_APP_API_STATUS_ADMIN, {
        tokenroom: this.tokenrooomSelect,
        tokenuser: this.token_admin,
        status: value,
        bot_id: this.tokenuser
      }).then((response) => {
        // console.log(response.data)
        this.status_admin = value
        this.status_admin_old = value
        // var listchat = JSON.parse(localStorage.getItem('listchat'))
        // var me = this
        // var index = _.findIndex(listchat, function (o) { return o.tokenroom === me.tokenrooomSelect })
        // if (index !== -1) {
        //   listchat[index].official_status = this.status_admin_old
        //   localStorage.setItem('listchat', JSON.stringify(listchat))
        //   localStorage.setItem('listchat_length', listchat.length)
        // }
      }).catch(error => {
        console.log(error)
      })
    },
    // closeDialogShowImage (value) {
    //   this.dialogshowimage = value
    // },
    play (e) {
      console.log(e)
    },
    closemodal () {
      document.getElementById('myModalFile').style.display = 'none'
    },
    closeImagedialog (value) {
      this.chatdialog_image = value
    },
    closeVideodialog (value) {
      this.chatdialog_video = value
    },
    closeInforfriend (value) {
      this.inforfrienddialog = value
    },
    detailFriendDialog (user) {
      // console.log(user)
      this.tokeninforfriend = user.tokenuser
      this.inforfrienddialog = true
    },
    getreply () {
      this.datepicker = false
      this.timepicker = false
      this.maxdate = ''
      this.mindate = ''
      this.maxtime = ''
      this.mintime = ''
      this.dateselect = ''
      this.timeselect = ''
      this.infodata = ''
      this.axios.post(process.env.VUE_APP_API_IMAGE + '/get_quickreply', {
        tokenroom: this.$route.params.roomid,
        tokenuser: this.$route.params.id
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.Quickreply = response.data.data.quick_reply
          // console.log(this.Quickreply)
        }
      })
    },
    toPageinfo () {
      this.$router.push('/infofriend/' + this.$route.params.id + '/' + this.$route.params.roomid)
    },
    append (emoji) {
      this.sendmsg += emoji
    },
    loadpic (filenameSend) {
      this.loading = true
      this.axios.get(this.pathSend, { responseType: 'blob' }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filenameSend)
        document.body.appendChild(link)
        link.click()
        this.loading = false
      })
    },
    loadfile (filenameSend) {
      this.loading = true
      this.axios.get(this.filepdf, { responseType: 'blob' }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filenameSend)
        document.body.appendChild(link)
        link.click()
        this.loading = false
      })
    },
    loadfilepdf (item) {
      // console.log(item)
      // this.loadingpdf = true
      this.axios.get(item.message, { responseType: 'blob' }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', item.file_name)
        document.body.appendChild(link)
        link.click()
        this.loadingpdf = false
      })
    },
    previewvideo (item) {
      this.chatdialog_video = true
      this.infor_video = item
      // console.log(item)
    },
    downloadURI (item) {
      this.loading = true
      if (this.extension(item.message) !== 'media') {
        this.axios.get(item.original_file, {
          responseType: 'blob'
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', item.file_name)
          document.body.appendChild(link)
          link.click()
          this.loading = false
        })
      } else {
        this.axios.get(item.message, {
          responseType: 'blob'
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', item.file_name)
          document.body.appendChild(link)
          link.click()
          this.loading = false
        })
      }
    },
    zoom (item) {
      // image slide
      // console.log(item)
      this.chatdialog_image = true
      this.infor_image = item
      // this.dialogshowimage = true
      // this.DetailImage = item
    },
    // zoom (tokenmessage, timestamp, nickname, alt, pic, url, type) {
    //   this.token_image = tokenmessage
    //   this.time_send = timestamp
    //   this.chatdialog_image = true
    //   this.nicknameSend = nickname
    //   this.filenameSend = alt
    //   this.picSend = pic
    //   this.dateSend = this.dateMoment(timestamp)
    //   this.timeSend = this.timeMoment(timestamp)
    //   this.tokenmsgSend = tokenmessage
    //   this.pathSend = url
    //   this.typeuser = type
    // },
    zoomfile (item, close) {
      // console.log(item)
      var modalfile = document.getElementById('myModalFile')
      modalfile.style.display = 'block'
      this.filepdf = item.message
      this.nicknameSend = item.nickname
      this.filenameSend = item.file_name
      this.pathSend = item.path_pic
      this.dateSend = this.dateMoment(item.timestamp)
      this.timeSend = this.timeMoment(item.timestamp)
      this.tokenmsgSend = item.tokenmessage
      this.typeuserSend = item.type
      if (close) {
        modalfile.style.display = 'none'
      }
    },
    getliststicker () {
      this.axios.post(process.env.VUE_APP_API_IMAGE + '/sticker/gettitleallsticker', { tokenuser: this.$route.params.id }).then((responsed) => {
        this.sticker = responsed.data['data']
      })
    },
    extension (path) {
      var extension = path.split('.')[path.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff']
      var media = ['mpg', 'mpeg', 'avi', 'wmv', 'mov', 'rm', 'ram', 'swf', 'flv', 'ogg', 'webm', 'mp4', 'divx', 'dat']
      var audio = ['mp3', 'wma', 'aac', 'ogg', 'm4a', 'wav', 'cda', 'flac', 'aiff', 'caf']
      if (pdf.includes(extension)) {
        return 'pdf'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else if (media.includes(extension)) {
        return 'media'
      } else if (audio.includes(extension)) {
        return 'audio'
      } else {
        return 'fas fa-file-alt'
      }
    },
    filename (index) {
      for (var x = 0; x < this.imageArray.length; x++) {
        if (this.imageArray[index].name !== undefined) {
          return this.imageArray[index].name
        } else {
          return this.imageArray[index]
        }
      }
    },
    insertImage () {
      document.getElementById('insertpic').click()
    },
    uppic () {
      document.getElementById('uploadpic').click()
    },
    // insertFile () {
    //   document.getElementById('insertfileChat').click()
    // },
    upfile () {
      document.getElementById('uploadfileChat').click()
    },
    allowDrop (event) {
      event.preventDefault()
    },
    drop (event) {
      event.preventDefault()
      // console.log(event.dataTransfer.files)
      this.imagesDrag(event)
    },
    imagesDrag (data) {
      for (var i = 0; i < data.dataTransfer.files.length; i++) {
        this.imageDrag.push(data.dataTransfer.files[i])
      }
      this.images = this.imageDrag
      if (this.images.length !== 0) {
        var files = data.dataTransfer.files
        this.preview_image = true
        this.chatlogsFlex = 'height: calc(86.7vh - 249px) !important;'
        this.createImage(files)
      }
    },
    imagesInsert (data) {
      // let images = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff']
      // for (let i = 0; i < data.target.files.length; i++) {
      //   let checkType = data.target.files[i].name.split('.')[data.target.files[i].name.split('.').length - 1].toLowerCase()
      //   this.check = checkType
      // }
      // if (images.includes(this.check)) {
      var files = data.target.files || data.dataTransfer.files
      this.images.push.apply(this.images, files)
      if (this.images.length !== 0) {
        this.createImage(files)
      }
      // }
    },
    imagesAdd (data) {
      // let images = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff']
      // for (let i = 0; i < data.target.files.length; i++) {
      //   let checkType = data.target.files[i].name.split('.')[data.target.files[i].name.split('.').length - 1].toLowerCase()
      //   this.check = checkType
      // }
      // if (images.includes(this.check)) {
      var files = data.target.files || data.dataTransfer.files
      this.images = []
      this.images.push.apply(this.images, files)
      if (this.images.length !== 0) {
        this.preview_image = true
        this.chatlogsFlex = 'height: calc(86.7vh - 249px) !important;'
        this.createImage(this.images)
      } else {
        this.menu_other = false
      }
    },
    createImage (file) {
      for (var i = 0; i < file.length; i++) {
        var reader = new FileReader()
        reader.fileName = file[i].name
        reader.onload = (e) => {
          this.image.push(e.target.result)
          this.imageArray.push(e.target.fileName)
          document.getElementById('uploadpic').value = ''
          document.getElementById('insertpic').value = ''
          document.getElementById('uploadfileChat').value = ''
          this.menu_other = false
        }
        // this.image = []
        reader.readAsDataURL(file[i])
      }
    },
    removeImage (key) {
      this.image.splice(key, 1)
      this.images.splice(key, 1)
      this.imageArray.splice(key, 1)
      if (this.image.length === 0) {
        this.preview_image = false
        this.chatlogsFlex = 'height: calc(100vh - 250px) !important;'
        // this.$refs.im.value = ''
      }
    },
    // filesDrag (data) {
    //   for (var i = 0; i < data.dataTransfer.files.length; i++) {
    //     this.fileArray.push(data.dataTransfer.files[i])
    //   }
    //   this.filespreview = this.fileArray
    //   if (this.filespreview.length !== 0) {
    //     this.preview_file = true
    //     this.chatlogsFlex = 'height: calc(86.7vh - 249px) !important;'
    //     this.createFile(this.filespreview)
    //   }
    // },
    // filesInsert (data) {
    //   var files = data.target.files || data.dataTransfer.files
    //   this.filespreview.push.apply(this.filespreview, files)
    //   if (this.filespreview.length !== 0) {
    //     this.createFile(this.filespreview)
    //   }
    // },
    // fileAdd (data) {
    //   var files = data.target.files || data.dataTransfer.files
    //   this.filespreview = []
    //   this.filespreview.push.apply(this.filespreview, files)
    //   if (this.filespreview.length !== 0) {
    //     this.preview_file = true
    //     this.chatlogsFlex = 'height: calc(86.7vh - 249px) !important;'
    //     this.createFile(this.filespreview)
    //   } else {
    //     this.menu_other = false
    //   }
    // },
    // createFile (file) {
    //   for (var i = 0; i < file.length; i++) {
    //     var reader = new FileReader()
    //     var vm = this
    //     reader.onload = (e) => {
    //       vm.filepreview.push(e.target.result)
    //       document.getElementById('insertfileChat').value = ''
    //       this.menu_other = false
    //     }
    //     vm.filepreview = []
    //     reader.readAsDataURL(file[i])
    //   }
    // },
    // removeFile (key) {
    //   this.filepreview.splice(key, 1)
    //   this.filespreview.splice(key, 1)
    //   if (this.filepreview.length === 0) {
    //     this.preview_file = false
    //     this.chatlogsFlex = 'height: calc(100vh - 250px) !important;'
    //   }
    // },
    onimgSelected () {
      let images = ['gif', 'jpeg', 'jpg', 'png', 'ico']
      for (let i = 0; i < this.images.length; i++) {
        let checkType = this.images[i].name.split('.')[this.images[i].name.split('.').length - 1].toLowerCase()
        this.check = checkType
        if (images.includes(this.check)) {
          console.log('send image')
          this.loading_file = true
          this.preview_image = false
          this.selectFile = this.images[i]
          var uploadFile = new FormData()
          uploadFile.append('file', this.selectFile, this.selectFile.name)
          uploadFile.append('tokenroom', this.$route.params.roomid)
          uploadFile.append('tokenuser', this.$route.params.id)
          uploadFile.append('type', 'bot')
          this.axios.post(process.env.VUE_APP_API_ALPINE + '/api/v1/pushFile', uploadFile).then((response) => {
            if (response.data.status === 'success') {
              this.loading_file = false
              this.preview_image = false
              this.image = []
              this.images = []
              this.imageArray = []
              this.selectFile = []
              this.imageDrag = []
              if (_.find(this.listmessage, function (o) { return o.tokenmessage === response.data.data.tokenmessage }) === undefined) {
                this.socketupdate_img = response.data.data
                response.data.data.status = 'success'
                this.listmessage.push(response.data.data)
                this.listmessage = _.sortBy(this.listmessage, function (dateObj) {
                  return new Date(dateObj.timestamp)
                })
                this.listmessage = _.unionBy(this.listmessage, 'tokenmessage')
                document.getElementById('uploadpic').value = ''
                document.getElementById('insertpic').value = ''
                document.getElementById('uploadfileChat').value = ''
              }
              setTimeout(this.scrollBottom, 1)
            }
          }, (error) => {
            console.log(error)
            // console.log(data)
            this.loading_file = false
            this.preview_image = false
            this.image = []
            this.images = []
            this.imageArray = []
            this.imageDrag = []
            this.selectFile = []
            this.$swal('Network error', 'โปรดตรวจการเชื่อมต่ออินเตอร์เน็ต', 'error')
          })
        } else if (this.extension(this.images[i].name) === 'media') {
          console.log('send video')
          this.loading_file = true
          this.preview_image = false
          this.selectFile = this.images[i]
          var uploadFiles = new FormData()
          uploadFiles.append('file', this.selectFile, this.selectFile.name)
          uploadFiles.append('tokenroom', this.$route.params.roomid)
          uploadFiles.append('tokenuser', this.$route.params.id)
          uploadFiles.append('type', 'bot')
          this.axios.post(process.env.VUE_APP_API_VIDEO, uploadFiles).then((response) => {
            if (response.data.status === 'success') {
              // console.log(response.data.data)
              this.preview_image = false
              this.loading_file = false
              this.image = []
              this.images = []
              this.imageArray = []
              this.selectFile = []
              this.imageDrag = []
              if (_.find(this.listmessage, function (o) { return o.tokenmessage === response.data.data.tokenmessage }) === undefined) {
                response.data.data.status = 'success'
                this.listmessage.push(response.data.data)
                this.listmessage = _.sortBy(this.listmessage, function (dateObj) {
                  return new Date(dateObj.timestamp)
                })
                this.listmessage = _.unionBy(this.listmessage, 'tokenmessage')
                document.getElementById('uploadpic').value = ''
                document.getElementById('insertpic').value = ''
                document.getElementById('uploadfileChat').value = ''
                this.socketupdate_file = response.data.data
              }
              setTimeout(this.scrollBottom, 1)
            }
          }, (error) => {
            console.log(error)
            this.preview_image = false
            this.loading_file = false
            this.image = []
            this.images = []
            this.imageArray = []
            this.selectFile = []
            this.imageDrag = []
            this.$swal('Network error', 'โปรดตรวจการเชื่อมต่ออินเตอร์เน็ต', 'error')
          })
        } else {
          console.log('send file')
          this.selectFile = this.images[i]
          var uploadfile = new FormData()
          this.loading_file = true
          this.preview_image = false
          uploadfile.append('file', this.selectFile, this.selectFile.name)
          uploadfile.append('tokenroom', this.$route.params.roomid)
          uploadfile.append('tokenuser', this.$route.params.id)
          uploadfile.append('type', 'bot')
          this.axios.post(process.env.VUE_APP_API_ALPINE + '/api/v1/pushFile', uploadfile).then((response) => {
            if (response.data.status === 'success') {
              this.loading_file = false
              this.preview_image = false
              this.image = []
              this.images = []
              this.imageArray = []
              this.selectFile = []
              this.imageDrag = []
              if (_.find(this.listmessage, function (o) { return o.tokenmessage === response.data.data.tokenmessage }) === undefined) {
                response.data.data.status = 'success'
                this.listmessage.push(response.data.data)
                this.listmessage = _.sortBy(this.listmessage, function (dateObj) {
                  return new Date(dateObj.timestamp)
                })
                this.listmessage = _.unionBy(this.listmessage, 'tokenmessage')
                document.getElementById('uploadpic').value = ''
                document.getElementById('insertpic').value = ''
                document.getElementById('uploadfileChat').value = ''
                this.socketupdate_file = response.data.data
              }
              setTimeout(this.scrollBottom, 1)
            }
          }, (error) => {
            console.log(error)
            this.loading_file = false
            this.preview_image = false
            this.image = []
            this.images = []
            this.imageArray = []
            this.selectFile = []
            this.imageDrag = []
            this.$swal('Network error', 'โปรดตรวจการเชื่อมต่ออินเตอร์เน็ต', 'error')
          })
        }
      }
      // if (data.target.files[0].type.split('/')[0].toLowerCase() === 'image') {
      //   this.selectFile = data.target.files[0]
      //   var uploadFile = new FormData()
      //   uploadFile.append('file', this.selectFile, this.selectFile.name)
      //   uploadFile.append('tokenroom', this.$route.params.roomid)
      //   uploadFile.append('tokenuser', this.$route.params.id)
      //   uploadFile.append('type', 'bot')
      //   this.axios.post(process.env.VUE_APP_API_IMAGE + '/push_image', uploadFile).then((response) => {
      //     if (response.data.status === 'success') {
      //       this.menu_other = false
      //       if (_.find(this.listmessage, function (o) { return o.tokenmessage === response.data.data.tokenmessage }) === undefined) {
      //         this.socketupdate_img = response.data.data
      //         response.data.data.status = 'success'
      //         this.listmessage.push(response.data.data)
      //         this.listmessage = _.sortBy(this.listmessage, function (dateObj) {
      //           return new Date(dateObj.timestamp)
      //         })
      //         this.listmessage = _.unionBy(this.listmessage, 'tokenmessage')
      //         document.querySelector('#uploadpic').value = ''
      //         document.querySelector('#uploadfileChat').value = ''
      //       }
      //       setTimeout(this.scrollBottom, 1)
      //     }
      //   }, (error) => {
      //     console.log(error)
      //     // console.log(data)
      //     this.$swal('Network error', 'โปรดตรวจการเชื่อมต่ออินเตอร์เน็ต', 'error')
      //   })
      // } else {
      //   this.onFileSelected(data)
      // }
    },
    // onFileSelected () {
    //   for (let i = 0; i < this.filespreview.length; i++) {
    //     this.selectFile = this.filespreview[i]
    //     var uploadFile = new FormData()
    //     uploadFile.append('file', this.selectFile, this.selectFile.name)
    //     uploadFile.append('tokenroom', this.$route.params.roomid)
    //     uploadFile.append('tokenuser', this.$route.params.id)
    //     uploadFile.append('type', 'bot')
    //     this.axios.post(process.env.VUE_APP_API_IMAGE + '/push_file', uploadFile).then((response) => {
    //       if (response.data.status === 'success') {
    //         this.preview_file = false
    //         this.filepreview = []
    //         this.filespreview = []
    //         if (_.find(this.listmessage, function (o) { return o.tokenmessage === response.data.data.tokenmessage }) === undefined) {
    //           response.data.data.status = 'success'
    //           this.listmessage.push(response.data.data)
    //           this.listmessage = _.sortBy(this.listmessage, function (dateObj) {
    //             return new Date(dateObj.timestamp)
    //           })
    //           this.listmessage = _.unionBy(this.listmessage, 'tokenmessage')
    //           document.querySelector('#uploadfileChat').value = ''
    //           this.socketupdate_file = response.data.data
    //         }
    //         setTimeout(this.scrollBottom, 1)
    //       }
    //     }, (error) => {
    //       console.log(error)
    //       this.$swal('Network error', 'โปรดตรวจการเชื่อมต่ออินเตอร์เน็ต', 'error')
    //     })
    //   }
    //   // if (data.target.files[0].type.split('/')[0].toLowerCase() === 'image') {
    //   //   this.onimgSelected(data)
    //   // } else {
    //   //   this.selectFile = data.target.files[0]
    //   //   var uploadFile = new FormData()
    //   //   uploadFile.append('file', this.selectFile, this.selectFile.name)
    //   //   uploadFile.append('tokenroom', this.$route.params.roomid)
    //   //   uploadFile.append('tokenuser', this.$route.params.id)
    //   //   uploadFile.append('type', 'bot')
    //   //   this.axios.post(process.env.VUE_APP_API_IMAGE + '/push_file', uploadFile).then((response) => {
    //   //     if (response.data.status === 'success') {
    //   //       this.menu_other = false
    //   //       if (_.find(this.listmessage, function (o) { return o.tokenmessage === response.data.data.tokenmessage }) === undefined) {
    //   //         response.data.data.status = 'success'
    //   //         this.listmessage.push(response.data.data)
    //   //         this.listmessage = _.sortBy(this.listmessage, function (dateObj) {
    //   //           return new Date(dateObj.timestamp)
    //   //         })
    //   //         this.listmessage = _.unionBy(this.listmessage, 'tokenmessage')
    //   //         document.querySelector('#uploadfileChat').value = ''
    //   //         this.socketupdate_file = response.data.data
    //   //       }
    //   //       setTimeout(this.scrollBottom, 1)
    //   //     }
    //   //   }, (error) => {
    //   //     console.log(error)
    //   //     this.$swal('Network error', 'โปรดตรวจการเชื่อมต่ออินเตอร์เน็ต', 'error')
    //   //   })
    //   // }
    // },
    async setStateWebhook (value) {
      await this.axios.post(process.env.VUE_APP_API_SWITCH_WEBHOOK, {
        tokenroom: this.tokenrooomSelect,
        block: value
      }).then((response) => {
        // console.log(response.data)
        console.log(`set new state webhook -> ${value}: ${response.data.status}`)
        if (response.data.status === 'success') {
          this.state_webhook = value
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getdataroom () {
      this.progressBoxChat = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/getroom', { tokenuser: this.$route.params.id, tokenroom: this.$route.params.roomid }).then((response) => {
        // console.log(response)
        if (response.data.status === 'success') {
          this.member_inroom = response.data.count_member
          this.infofriend = response.data
          // console.log(this.infofriend)
          var me = this
          this.listfriend = _.filter(response.data.data_room, function (o) { return o.tokenuser !== me.$route.params.id && o.type === 'user' && o.statemember === 'active' })
          // console.log(this.listfriend)
          this.progressBoxChat = false
          this.statemember = response.data.statemember
          // console.log(response.data.official_status)
          // console.log(this.state_webhook)
          // console.log(this.status_admin)
          if (response.data.official_status !== undefined) {
            this.status_admin = response.data.official_status
            this.status_admin_old = response.data.official_status
          } else {
            this.status_admin = ''
            this.status_admin_old = ''
          }
          // console.log(JSON.parse(localStorage.getItem('listchat')))
          var listchat = JSON.parse(localStorage.getItem('listchat'))
          // var me = this
          var index = _.findIndex(listchat, function (o) { return o.tokenroom === me.tokenrooomSelect })
          if (index !== -1) {
            listchat[index].official_status = this.status_admin
          }
          // console.log(listchat[index])
          localStorage.setItem('listchat', JSON.stringify(listchat))
          localStorage.setItem('listchat_length', listchat.length)
        } else {
          this.progressBoxChat = false
        }
      })
    },
    sendMessages () {
      this.resetIcon()
      this.clearMessage()
    },
    clearMessage () {
      this.message = ''
    },
    resetIcon () {
      this.iconIndex = 0
    },
    toPage (data) {
      this.$router.push(data + this.$route.params.id)
    },
    convert (msg) {
      var linkifyStr = require('linkifyjs/string')
      var str = msg
      var processedContent = linkifyStr(str)
      var regex = /\s|<tax>+[\u0E00-\u0E7Fa-zA-Z'|/^\S+@\S+\S+$/]+<\/tax>/g
      // console.log(msg.match(regex))
      if (msg.match(regex)) {
        for (var i = 0; i < msg.match(regex).length; i++) {
          processedContent = processedContent.replace('&lt;tax&gt;', '<b style="color:#1976d2;">@')
          processedContent = processedContent.replace('&lt;/tax&gt;', '</b>')
          processedContent = processedContent.replace('\t', '\u00a0\u00a0\u00a0\u00a0\u00a0')
          // processedContent = processedContent.replace(' ', '&nbsp;')
          // processedContent = processedContent.replace(/ /g, '\u00a0')
        }
      }
      return processedContent
    },
    // chsheetother () {
    //   document.getElementById('tabother').click()
    //   this.sheetother = !this.sheetother
    // },
    // chsheetsticker () {
    //   document.getElementById('tabsticker').click()
    //   this.sheetsticker = !this.sheetsticker
    // },
    // getimage (time) {
    //   this.axios.post(process.env.VUE_APP_API_PUB + '/file/twe_img', { tokenuser: this.tokenuser, tokenroom: this.tokenrooomSelect, time_in: time, type: 'bot' }).then((response) => {
    //     if (time === '') {
    //       this.get_data = response.data['data']
    //     } else {
    //       this.get_data.push.apply(this.get_data, response.data['data'])
    //       this.data_unionBy = _.unionBy(this.get_data, 'timestamp')
    //       console.log(this.data_unionBy)
    //     }
    //   })
    // },
    get_scroll () {
      var elmnt = document.getElementById('myscroll')
      var unwantedHeight = 64 + 64 + 118
      var scrollTop = Math.floor(elmnt.scrollTop)
      var wantedHeight = screen.height - unwantedHeight
      var totalHeight = elmnt.scrollHeight - wantedHeight
      if (scrollTop > totalHeight) {
        this.alert = false
        this.chatlogsFlex = 'height: calc(100vh - 250px) !important;'
        if (this.preview_image === true) {
          this.chatlogsFlex = 'height: calc(86.7vh - 249px) !important;'
        }
        if (this.preview_file === true) {
          this.chatlogsFlex = 'height: calc(86.7vh - 249px) !important;'
        }
      }
      if (scrollTop === 0) {
        if (this.statusload) {
          this.loadchathistory()
        }
      }
    },
    close_alert () {
      this.alert = false
      this.chatlogsFlex = 'height: calc(100vh - 250px) !important;'
      var container = this.$el.querySelector('#myscroll')
      if (this.alert === false) {
        container.scrollTop = container.scrollHeight
        this.scrollval = container.scrollTop
      }
    },
    scrollDown () {
      var container = this.$el.querySelector('#myscroll')
      this.scrollval = container.scrollTop
      container.scrollTop = container.scrollHeight
      if (this.check_scroll !== '') {
        var scrollMaxNew = container.scrollHeight
        container.scrollTop = scrollMaxNew - this.scrollMaxOld
        this.scrollMaxOld = scrollMaxNew
        this.scrollval = container.scrollTop
      }
    },
    scrollBottom () {
      var container = this.$el.querySelector('#myscroll')
      container.scrollTop = container.scrollHeight
      this.scrollval = container.scrollTop
      this.alert = false
    },
    isBlank (str) {
      return (!str || /^\s*$/.test(str))
    },
    isEmpty (str) {
      return (!str || str.length === 0)
    },
    dateMoment (data) {
      return Momenttime.momentdatethai(data)
    },
    timeMoment (data) {
      return Momenttime.momenttimethai(data)
    },
    datetime (data) {
      return Momenttime.momentdatethai(data)
    },
    sendMessage (data) {
      // console.log(data)
      // var test = data.trim()
      var test = data
      let replaced = data.replace(/(\r\n|\n|\r)/gm, '')
      try {
        if (event.keyCode === 13 || event.which === 1) {
          if (event.shiftKey && replaced !== '') {
            this.sendmsg.pasteIntoInput(this.sendmsg, '\n')
          } else {
            if (!this.isBlank(test) && !this.isEmpty(test)) {
              // ถ้ามี space แทนด้วย \u00a0
              for (var k = 0; k < test.length; k++) {
                test = test.replace(/ /g, '\u00a0')
              }
              this.axios.post(process.env.VUE_APP_API_NEW_PUSHMESSAGE, {
                tokenroom: this.$route.params.roomid,
                tokenuser: this.$route.params.id,
                // type: 'bot',
                admin: this.token_admin,
                message: test
              }).then((response) => {
                var messageSendChat = response.data.data
                if (response.data.status === 'success') {
                  messageSendChat['status'] = 'success'
                  if (_.find(this.listmessage, function (o) { return o.tokenmessage === messageSendChat.tokenmessage }) === undefined) {
                    // console.log(messageSendChat)
                    this.listmessage.push(messageSendChat)
                    this.listmessage = _.sortBy(this.listmessage, function (dateObj) {
                      return new Date(dateObj.timestamp)
                    })
                    this.listmessage = _.unionBy(this.listmessage, 'tokenmessage')
                  }
                  setTimeout(this.scrollBottom, 1)
                  this.sendmsg = ''
                } else {
                  this.listmessage.push({ tokenuser: this.$route.params.id, message: data, tokenroom: this.$route.params.roomid, typeofmessage: 'message', timestamp: Momenttime.momenttimestamp(), tokenmessage: btoa(Momenttime.momenttimestamp()), path_pic: this.profile, nickname: '', file_name: '', status: 'no' })
                  this.sendmsg = ''
                }
              }, (error) => {
                this.sendmsg = ''
                this.$swal('Network error', 'โปรดตรวจการเชื่อมต่ออินเตอร์เน็ต', 'error')
                this.listmessage.push({
                  tokenuser: this.$route.params.id,
                  message: data,
                  tokenroom: this.$route.params.roomid,
                  typeofmessage: 'message',
                  timestamp: Momenttime.momenttimestamp(),
                  tokenmessage: btoa(Momenttime.momenttimestamp()),
                  path_pic: this.profile,
                  nickname: '',
                  file_name: '',
                  status: 'no'
                })
                setTimeout(this.scrollBottom, 1)
                console.log(error)
              })
            }
          }
          event.preventDefault()
        }
      } catch (e) {
        // console.log(e)
      }
      if (this.images.length !== 0 && this.loading_file !== true) {
        this.onimgSelected()
      }
      // if (this.filespreview.length !== 0) {
      //   this.onFileSelected()
      // }
    },
    pushSticker (stickerid) {
      this.axios.post(process.env.VUE_APP_API_IMAGE + '/push_sticker', { tokenroom: this.$route.params.roomid, tokenuser: this.$route.params.id, message: stickerid, type: 'bot' }).then((response) => {
        var messageSendChat = response.data.data
        if (response.data.status === 'success') {
          this.menu_emoji = false
          messageSendChat['status'] = 'success'
          if (_.find(this.listmessage, function (o) { return o.tokenmessage === messageSendChat.tokenmessage }) === undefined) {
            // console.log(messageSendChat)
            this.listmessage.push(messageSendChat)
            this.listmessage = _.sortBy(this.listmessage, function (dateObj) {
              return new Date(dateObj.timestamp)
            })
            this.listmessage = _.unionBy(this.listmessage, 'tokenmessage')
          }
          setTimeout(this.scrollBottom, 1)
          this.sheetsticker = false
          // this.sendmsg = ''
        }
      })
    },
    getMessageFirst (time) {
      if (time === '') {
        this.progressLoadChat = true
      }
      // process.env.VUE_APP_API_PUB + '/v3/message/getdictmessage'
      this.axios.post(process.env.VUE_APP_API_NEW_GETDICT, {
        tokenroom: this.$route.params.roomid,
        tokenuser: this.$route.params.id,
        time_in: time
        // type: 'bot'
      }).then((response) => {
        // console.log(response.data.data)
        this.progressLoadChat = false
        if (response.data['status'] === 'success') {
          // console.log(response.data.data)
          this.statemember = response.data.state_member
          this.listmessage.unshift.apply(this.listmessage, response.data['data'].reverse())
          if (response.data.data.length === 20) {
            this.statusload = true
          } else if (response.data.data.length < 20) {
            this.statusload = false
          }
          // console.log(this.listmessage)
          // this.selectedmessage = this.temp
          setTimeout(this.scrollDown, 1)
        } else {
          if (response.data.message === 'not member.') {
            this.$router.push('/chat/not_permission')
          } else if (response.data.message === 'Tokenroom not found.') {
            // console.log(this.statemember)
            // this.$router.push('/chat/not_found')
          }
        }
      }).catch((error) => {
        this.progressLoadChat = false
        if (error.response.data.message === 'Tokenroom not found.') {
          this.$router.push('/chat/not_found')
        }
      })
    },
    getMessageSocket (data) {
      // console.log(data)
      if (data.tokenroom === this.$route.params.roomid) {
        if (_.find(this.listmessage, function (o) { return o.tokenmessage === data.tokenmessage }) === undefined) {
          // console.log(this.listmessage)
          this.listmessage.push(data)
          // console.log(this.listmessage)
          this.listmessage = _.sortBy(this.listmessage, function (dateObj) {
            return new Date(dateObj.timestamp)
          })
          this.listmessage = _.unionBy(this.listmessage, 'tokenmessage')
          if (data.type !== 'bot') {
            var elmnt = document.getElementById('myscroll')
            var unwantedHeight = 64 + 64 + 118
            var scrollTop = Math.floor(elmnt.scrollTop)
            var wantedHeight = screen.height - unwantedHeight
            var totalHeight = elmnt.scrollHeight - wantedHeight
            if (scrollTop >= totalHeight) {
              setTimeout(this.scrollBottom, 1)
            } else {
              this.alert = true
              this.chatlogsFlex = 'height: calc(94.6vh - 250px) !important;'
            }
          } else {
            this.alert = false
          }
          // setTimeout(this.scrollBottom, 1)
          if (data.typeofmessage === 'file') {
            this.socketupdate_file = data
          } else if (data.typeofmessage === 'image') {
            this.socketupdate_img = data
          }
          if (data.tokenuser !== this.$route.params.id) {
            this.axios.post(process.env.VUE_APP_API_PUB + '/mark_read', { tokenuser: this.$route.params.id, tokenroom: data.tokenroom }).then((response) => {
            })
          }
        }
      }
    },
    loadchathistory () {
      // this.chatdialog_image = false
      this.progressLoadChat = true
      // this.temp = this.selectedmessage
      // this.selectedmessage = []
      var container = this.$el.querySelector('#myscroll')
      this.scrollval = container.scrollTop
      this.check_scroll = this.scrollval
      if (this.scrollval < 20) {
        // console.log(this.scrollMaxOld)
        this.getMessageFirst(this.listmessage[0].timestamp)
        var scrollMaxNew = container.scrollHeight
        container.scrollTop = scrollMaxNew - this.scrollMaxOld
        this.scrollMaxOld = scrollMaxNew
        this.scrollval = container.scrollTop
      }
    }
  }
}
</script>
<style type="text/css" scoped>
.scrolling-wrapper-template {
  display: flex;
  overflow-x: auto;
}
.scrolling-wrapper-template::-webkit-scrollbar {
  height: 8px;
  width: 8px;
  /* cursor: pointer; */
}
.scrolling-wrapper-template::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}
>>>video::-webkit-media-controls-fullscreen-button {
  display: none;
}
.long_text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 105px;
}
.card-file:hover {
  border-radius: 10px;
  border-style: solid;
  border-width: thin;
  border-color: #c5c5c5;
  background-color: #eee;
  cursor: pointer;
}
.my-menu-other {
  border: lightgrey 1px solid;
  border-radius: 10px;
  max-width: 350px !important;
}
.my-menu-emo {
  border: lightgrey 1px solid;
  border-radius: 10px;
  /* max-width: 28.125em; */
  max-width: 350px !important;
}
.item:hover {
  border-radius: 30px;
  border: 2px solid rgb(76, 184, 33);
  padding: 10px;
}
.quick_replydis {
  background: white !important;
  text-transform: none;
  font-weight: 200;
  border: lightgrey 1px solid;
  color: #2160b0;
  cursor: no-drop !important;
}
.chat_selfapprove {
  word-wrap: break-word;
  max-width: 200px;
  border-radius: 25px;
  padding: 12px;
  float: right;
  text-align: left;
}
.chat_selfweb {
  word-wrap: break-word;
  max-width: 340px;
  background: #60b8e3cc;
  border-radius: 25px;
  padding: 12px;
  float: right;
  text-align: left;
}
.chat_otherweb {
  word-wrap: break-word;
  max-width: 340px;
  background: #E0E0E0;
  border-radius: 25px;
  padding: 12px;
  float: right;
  text-align: left;
}
.boxfriendquestion {
  text-align: left;
  margin: 20px auto;
  margin-top: 0;
  border-radius: 20px;
  background: #d4d7d8;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size: 13px;
  position: relative;
  word-wrap: break-word;
  margin-top: 0px !important;
  float: right;
  max-width: 40vw;
}
.boxother_unsend {
  border-radius: 10px;
  background-color: #80808021;
  border-width: thin;
  text-align: center;
  font-size: 13px;
  max-width: 225px;
  padding-left: 5px;
  padding-right: 5px;
  word-break: break-all;
}
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 4px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.scrolling-wrapper-quickreply {
  display: flex;
  overflow-x: auto;
}

.scrolling-wrapper-quickreply::-webkit-scrollbar {
  height: 5px;
}

.scrolling-wrapper-quickreply::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}
.scrolling-image {
  height: 95px !important;
  background-color: #cfd0d0 !important;
  border-radius: 15px;
  overflow: auto;
  overflow-y: hidden;
}
.scrolling-image::-webkit-scrollbar {
  height: 5px;
  width: 8px;
}
.scrolling-image::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.text2 {
  white-space: nowrap;
  width: 165px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px !important;
  color: black !important;
}
.textfile {
  width: 90px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px !important;
  color: black !important;
}
.chat_selfcontact {
  text-align: left;
  border-radius: 20px;
  background: #60b8e3cc;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size:13px;
  position: relative;
  word-wrap: break-word;
  float: right;
  width: 195px;
}
.chat_selfnote {
  text-align: left;
  border-radius: 20px;
  background: #60b8e3cc;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size:13px;
  position: relative;
  word-wrap: break-word;
  float: right;
  width: 195px;
}
.chat_carousel {
  text-align: left;
  border-radius: 20px;
  background: #60b8e3cc;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size:13px;
  position: relative;
  word-wrap: break-word;
  float: right;
  width: 300px;
}
.chat_template_official {
  text-align: left;
  border-radius: 20px;
  font-weight: 300;
  color: black;
  font-size:13px;
  position: relative;
  word-wrap: break-word;
  float: right;
  width: 195px;
}
.chat_othercontact {
  text-align: left;
  border-radius: 20px;
  background: #E0E0E0;
  color: black;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size:13px;
  position: relative;
  word-wrap: break-word;
  margin-top: 0px !important;
  float: left;
  width: 195px;
}
.chat_othernote {
  text-align: left;
  border-radius: 20px;
  background: #E0E0E0;
  color: black;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size:13px;
  position: relative;
  word-wrap: break-word;
  margin-top: 0px !important;
  float: left;
  width: 195px;
}
.template_official {
  text-align: left;
  border-radius: 20px;
  color: black;
  font-weight: 300;
  font-size:13px;
  position: relative;
  word-wrap: break-word;
  margin-top: 0px !important;
  float: left;
  width: 195px;
}
.bordercard {
  border-radius: 15px;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
  /*box-shadow: none;*/
  border-width: thin !important;
  border-style: solid !important;
  border-radius: 20px !important;
  border-color: #808080a6 !important;
  box-shadow: none !important;
  margin-right: 0.3em !important;
  min-height: 10px !important;
}
.chatbox {
  width: 100%;
  min-width: 10vw;
  height: calc(100% - 128px);
  background-color:#eceff1;
}
.centerbox {
  height: calc(100vh - 64px);
  background: #eceff1 !important;
}
.chat_self {
  word-wrap: break-word;
  max-width: 200px;
  background: #60b8e3cc;
  border-radius: 25px;
  padding: 12px;
  float: right;
  text-align: left;
}
.chat_other {
  word-wrap: break-word;
  max-width: 200px;
  border-radius: 20px;
  background: #E0E0E0;
  padding: 12px;
  float: left;
  color: black;
  text-align: left;
}
.chat_selfimage {
  /* width: 200px; */
  /* width: 150px; */
  max-width: 25vw;
  border-radius: 25px;
  padding: 12px;
  float: right;
  text-align: left;
  cursor: pointer;
}
.chat_otherimage {
  /* width: 200px; */
  /* width: 150px; */
  max-width: 25vw;
  border-radius: 25px;
  padding: 12px;
  float: left;
  color: black;
  text-align: left;
  cursor: pointer;
}
.chat_selffile {
  word-wrap: break-word;
  width: 200px;
  height: 180px;
  background: #60b8e3cc;
  border-radius: 25px;
  padding: 12px;
  float: right;
  text-align: left;
}
.chat_otherfile {
  word-wrap: break-word;
  width: 200px;
  height: 180px;
  background: #E0E0E0;
  border-radius: 25px;
  padding: 12px;
  float: left;
  text-align: left;
}
.chat_otheraudio {
  width: 200px;
  background: #E0E0E0;
  border-radius: 25px;
  padding: 12px;
  float: left;
  text-align: left;
}
.chat_othervideo {
  width: 200px !important;
  /* height: 215px !important; */
  background: #E0E0E0 !important;
  border-radius: 25px !important;
  padding: 12px !important;
  float: left !important;
  text-align: left !important;
}
.chat_selfvideo {
  width: 200px !important;
  /* height: 215px !important; */
  background: #60b8e3cc !important;
  border-radius: 25px !important;
  padding: 12px !important;
  float: right !important;
  text-align: left !important;
}
.chat_othersticker {
  float: left;
  width: 140px;
  height: auto;
}
.chat_selfsticker {
  float: right;
  width: 140px;
  height: auto;
}
.chatlogs{
  padding: 20px;
  padding-top: 0px;
  width: 100%;
  /* height: 90%; */
  height: calc(100vh - 250px);
  overflow-x: hidden;
  overflow-y: scroll;
  margin-top: 2vh;
  margin-bottom: 0.5vh;
  background: #eceff1;
}
.chatlogs::-webkit-scrollbar{
  width: 10px;
}
.chatlogs::-webkit-scrollbar-thumb{
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}
.conversation-start {
  position: relative;
  width: 100%;
  margin-bottom: 2vh;
  text-align: center;
}
.conversation-start span {
  border-style: solid;
  font-size: 10px;
  display: inline-block;
  color: #424242;
  border-width: thin;
  border-radius: 10px;
  width: 80px;
}
.conversation-start span:before, .conversation-start span:after {
  position: absolute;
  top: 12px;
  display: inline-block;
  width: 120px;
  height: 1px;
  content: '';
}
.conversation-start span:before {
  left: 0;
}
.conversation-start span:after {
  right: 0;
}
.modalc {
  overflow-x: hidden !important;
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  /*padding-top: 20vh;  Location of the box */
  left: 0;
  top: 0;
  width: 100vw; /* Full width */
  height: 100vh; /* Full height */
  overflow: auto; /* Enable scroll if needed */
 /* background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
  /*background-color: white;*/
}

/* Modal Content (Image) */
.modal-contentc {
    padding-top: 10vh;
    margin: auto;
    display: block;
    width: 80%;
    width: auto;
    height: 70vh;
}

/* Caption of Modal Image (Image Text) - Same Width as the Image */
#caption {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 100vw;
    text-align: center;
    color: #ccc;
    padding: 10px 0;
    height: 150px;
}

#headcaption {
    /*margin: auto;*/
    display: block;
    margin-top: 45px;

    /*width: 80%;*/
    /*max-width: 100vw;*/
    text-align: left;
    color: white;
    /*padding-left: 15vw ;*/
    padding-top: 1vh;
    padding-bottom: 1vh;
    /*background-color: white;*/
    background-color: #1b232d;
    /*height: 150px;*/
}
/* Add Animation - Zoom in the Modal */
.modal-content, #caption {
    animation-name: zoom;
    animation-duration: 0.6s;
}

@keyframes zoom {
    from {transform:scale(0) }
    to {transform:scale(1) }
}

/* The Close Button */
.closeR {
    margin-top: 45px;
    position: absolute;
    top: 15px;
    right: 35px;
    color: white;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
}

.closeR:hover,
.closeR:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px){
    .modal-content {
        width: 100vw;
    }
}
/*.picgroup:hover {
  background: black !important;
}
*/
.btncancel {
  border-style: solid !important;
  color: white !important;
  background-color: #607d8b !important;
  border-radius: 8px !important;
  border-color: #607d8b !important;
  border-width: thin !important;
}
.btnallow {
  border-style: solid !important;
  color: white !important;
  background-color: #607d8b !important;
  border-radius: 8px !important;
  border-color: #607d8b !important;
  border-width: thin !important;
}
>>>.v-alert.v-alert {
  border: none;
  border-color: #eceff1 !important;
}
>>>.primary {
  background-color: #8a929a !important;
  border-color: #47494b !important;
}
>>>.v-text-field.v-text-field--solo .v-input__control {
    min-height: 0px;
    padding: 0;
}
.selecStatus{
    max-width: 150px;
}
</style>
